import { Colors } from "../Theme/colors"

export function ProjectIcon(props) {
  return (
    <svg
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
      className={props.className}
    >
      <path
        d="M8.88799 20.3374C9.06639 20.5113 9.06639 20.7928 8.88799 20.9667L6.99054 22.816C6.90156 22.9027 6.78455 22.9465 6.66755 22.9465C6.55054 22.9465 6.43398 22.9032 6.34456 22.816L5.39605 21.8913C5.21765 21.7174 5.21765 21.4359 5.39605 21.262C5.57446 21.0881 5.86319 21.0881 6.04159 21.262L6.66755 21.8723L8.24201 20.3374C8.42041 20.1634 8.70959 20.1634 8.88799 20.3374ZM8.24201 26.4249L6.66755 27.9598L6.04159 27.3495C5.86319 27.1756 5.57446 27.1756 5.39605 27.3495C5.21765 27.5235 5.21765 27.8049 5.39605 27.9789L6.34456 28.9035C6.43354 28.9903 6.55054 29.0341 6.66755 29.0341C6.78455 29.0341 6.90111 28.9907 6.99054 28.9035L8.88799 27.0538C9.06639 26.8798 9.06639 26.5984 8.88799 26.4244C8.70959 26.2514 8.42041 26.2514 8.24201 26.4249ZM12.3581 16.3538H25.7386C25.9908 16.3538 26.195 16.1547 26.195 15.9088C26.195 15.6629 25.9908 15.4638 25.7386 15.4638H12.3581C12.1059 15.4638 11.9017 15.6629 11.9017 15.9088C11.9017 16.1547 12.1059 16.3538 12.3581 16.3538ZM12.3581 10.2658H25.7386C25.9908 10.2658 26.195 10.0667 26.195 9.82081C26.195 9.5749 25.9908 9.37583 25.7386 9.37583H12.3581C12.1059 9.37583 11.9017 9.5749 11.9017 9.82081C11.9017 10.0667 12.1059 10.2658 12.3581 10.2658ZM8.24201 8.16145L6.66755 9.69634L6.04159 9.08611C5.86319 8.9122 5.57446 8.9122 5.39605 9.08611C5.21765 9.26003 5.21765 9.54151 5.39605 9.71542L6.34456 10.6401C6.43354 10.7268 6.55054 10.7706 6.66755 10.7706C6.78455 10.7706 6.90111 10.7273 6.99054 10.6401L8.88799 8.79032C9.06639 8.61641 9.06639 8.33493 8.88799 8.16101C8.70959 7.98796 8.42041 7.98797 8.24201 8.16145ZM8.24201 14.2494L6.66755 15.7843L6.04159 15.1741C5.86319 15.0002 5.57446 15.0002 5.39605 15.1741C5.21765 15.348 5.21765 15.6295 5.39605 15.8034L6.34456 16.728C6.43354 16.8148 6.55054 16.8586 6.66755 16.8586C6.78455 16.8586 6.90111 16.8152 6.99054 16.728L8.88799 14.8783C9.06639 14.7044 9.06639 14.4229 8.88799 14.249C8.70959 14.0759 8.42041 14.0755 8.24201 14.2494ZM41.8872 31.956C41.7599 32.8108 41.0254 33.4306 40.1396 33.431C40.1374 33.431 40.1347 33.431 40.1325 33.431C39.3557 33.431 38.6328 33.8374 38.2449 34.4923C37.8565 35.1485 37.8574 35.9634 38.2475 36.6196C38.6924 37.3682 38.5096 38.2998 37.8129 38.835C36.9814 39.4738 36.0591 39.9917 35.0719 40.3742C34.2493 40.693 33.3311 40.3816 32.8893 39.6334C32.5013 38.9764 31.778 38.5687 31.0012 38.5687C30.2244 38.5687 29.501 38.9768 29.1131 39.6343C28.7874 40.1856 28.2042 40.5 27.5907 40.5C27.3696 40.5 27.1449 40.4592 26.9264 40.3742C26.4388 40.1843 25.9597 39.957 25.5024 39.6998C25.0446 39.4422 24.6037 39.1512 24.1913 38.835C23.4937 38.2998 23.3104 37.3678 23.7553 36.6192C23.7655 36.6018 23.7744 36.5836 23.7846 36.5663H0.456456C0.204204 36.5663 0 36.3672 0 36.1213V0.944984C0 0.699072 0.204204 0.5 0.456456 0.5H31.0012C31.2534 0.5 31.4576 0.699072 31.4576 0.944984V22.2127C32.0533 22.0874 32.5788 21.7213 32.8893 21.1952C33.332 20.4454 34.2515 20.1339 35.0759 20.4553C35.5635 20.6453 36.0427 20.8726 36.5 21.1297C36.9578 21.3874 37.3987 21.6784 37.8111 21.995C38.5087 22.5302 38.692 23.4618 38.2471 24.2108C37.8574 24.867 37.8565 25.6819 38.2444 26.3377C38.6324 26.9926 39.3553 27.399 40.1321 27.399C40.1339 27.399 40.1352 27.399 40.1365 27.399C41.021 27.399 41.7559 28.0179 41.8836 28.8714C42.0375 29.8971 42.0389 30.935 41.8872 31.956ZM24.044 35.6759C24.068 35.2686 23.9728 34.8557 23.7575 34.4923C23.3696 33.8374 22.6466 33.431 21.8698 33.431C21.8685 33.431 21.8667 33.431 21.8654 33.431C20.9809 33.431 20.246 32.8121 20.1183 31.9586C19.9648 30.9333 19.9635 29.8958 20.1152 28.8749C20.133 28.7548 20.1641 28.6398 20.2046 28.5301H12.3581C12.1059 28.5301 11.9017 28.331 11.9017 28.0851C11.9017 27.8392 12.1059 27.6401 12.3581 27.6401H20.9569C21.2221 27.487 21.5317 27.4003 21.8632 27.4003C21.8654 27.4003 21.8681 27.4003 21.8703 27.4003C22.6471 27.4003 23.37 26.9939 23.7579 26.339C24.1463 25.6828 24.1454 24.8679 23.7553 24.2117C23.4172 23.6431 23.4421 22.9687 23.7793 22.4426H12.3581C12.1059 22.4426 11.9017 22.2435 11.9017 21.9976C11.9017 21.7517 12.1059 21.5526 12.3581 21.5526H24.811C25.4725 21.1141 26.1826 20.7468 26.9304 20.4566C27.7535 20.1379 28.6713 20.4493 29.1131 21.1974C29.4236 21.7231 29.949 22.0887 30.5447 22.214V1.38997H0.913356V35.6759H24.044ZM40.9805 29.0007C40.9186 28.5886 40.5636 28.2894 40.1365 28.2894C40.1352 28.2894 40.1339 28.2894 40.1321 28.2894C39.0301 28.2894 38.0042 27.7126 37.4538 26.7831C36.9026 25.8524 36.904 24.6957 37.457 23.765C37.6718 23.4032 37.5833 22.9531 37.2465 22.6946C36.8684 22.4044 36.4635 22.1372 36.0435 21.9009C35.6236 21.6645 35.184 21.4563 34.7369 21.282C34.3392 21.1267 33.8947 21.2768 33.6807 21.6393C33.1304 22.5718 32.1036 23.1508 31.0012 23.1513C29.8992 23.1513 28.8724 22.5723 28.3221 21.6407C28.1085 21.2794 27.665 21.1289 27.2677 21.2828C26.3619 21.6337 25.5166 22.1086 24.7545 22.6941C24.4177 22.9526 24.3296 23.4028 24.5445 23.7641C25.0984 24.6953 25.0997 25.852 24.5481 26.7831C23.9977 27.7126 22.9718 28.2894 21.8698 28.2894C21.8676 28.2894 21.8649 28.2894 21.8627 28.2894C21.4347 28.2894 21.0802 28.5886 21.0188 29.0015C20.88 29.9375 20.8808 30.889 21.0214 31.8289C21.0833 32.2409 21.4383 32.5402 21.8654 32.5402C21.8667 32.5402 21.8681 32.5402 21.8698 32.5402C22.9718 32.5402 23.9977 33.117 24.5481 34.0464C25.0993 34.9772 25.0979 36.1339 24.545 37.0646C24.3301 37.4263 24.4186 37.8765 24.7554 38.135C25.1335 38.4251 25.5384 38.6923 25.9584 38.9287C26.3779 39.165 26.8179 39.3732 27.265 39.5476C27.6627 39.7028 28.1072 39.5523 28.3212 39.1902C28.8715 38.2577 29.8983 37.6787 31.0007 37.6787C32.1027 37.6787 33.1295 38.2577 33.6799 39.1893C33.8934 39.5506 34.3365 39.7011 34.7342 39.5471C35.6396 39.1963 36.4853 38.7214 37.2474 38.1359C37.5842 37.8774 37.6723 37.4272 37.4574 37.0659C36.9035 36.1347 36.9022 34.978 37.4538 34.0469C38.0042 33.1174 39.0301 32.5406 40.1321 32.5406C40.1343 32.5406 40.1365 32.5406 40.1392 32.5406C40.5672 32.5406 40.9218 32.2413 40.9831 31.8284C41.1224 30.8921 41.1215 29.941 40.9805 29.0007ZM34.5038 32.3862C33.9637 33.2983 33.0917 33.9506 32.048 34.2234C31.6997 34.3145 31.346 34.3596 30.9945 34.3596C30.2938 34.3596 29.602 34.1804 28.9787 33.8296C28.0431 33.3031 27.374 32.453 27.0942 31.4355C26.8143 30.418 26.958 29.3559 27.4981 28.4438C28.613 26.5611 31.0915 25.9135 33.0228 27.0008C34.9545 28.0877 35.6187 30.5035 34.5038 32.3862ZM29.4356 33.0584C29.7835 33.254 30.159 33.3803 30.5447 33.4358V27.3977C29.6314 27.53 28.7856 28.0504 28.2896 28.8888C27.8714 29.5949 27.7602 30.4176 27.9768 31.2052C28.193 31.9928 28.7113 32.6508 29.4356 33.0584ZM32.5667 27.7715C32.2139 27.5729 31.838 27.4506 31.4576 27.3964V33.4349C31.576 33.4175 31.6943 33.3946 31.8113 33.3638C32.6192 33.1526 33.2946 32.6477 33.7128 31.9416C34.5763 30.4835 34.062 28.6129 32.5667 27.7715Z"
        fill="currentcolor"
      />
    </svg>
  )
}
export function WorkPlanIcon({ className }) {
  return (
    <div className="-ml-1">
      <svg
        fill="CurrentColor"
        width="64px"
        height="64px"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        stroke="CurrentColor"
        className={className}
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path d="M39,32H61a2,2,0,0,0,2-2V26a6,6,0,0,0-6-6H43a6,6,0,0,0-6,6v4A2,2,0,0,0,39,32Zm33-7H70a.94.94,0,0,0-1,1v4a8,8,0,0,1-8,8H39a8,8,0,0,1-8-8V26a.94.94,0,0,0-1-1H28a6,6,0,0,0-6,6V74a6,6,0,0,0,6,6H72a6,6,0,0,0,6-6V31A6,6,0,0,0,72,25ZM39,68a2,2,0,0,1-2,2H35a2,2,0,0,1-2-2V66a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Zm0-10a2,2,0,0,1-2,2H35a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2Zm0-10a2,2,0,0,1-2,2H35a2,2,0,0,1-2-2V46a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2ZM67,68a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V66a2,2,0,0,1,2-2H65a2,2,0,0,1,2,2Zm0-10a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H65a2,2,0,0,1,2,2Zm0-10a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V46a2,2,0,0,1,2-2H65a2,2,0,0,1,2,2Z"></path>{" "}
        </g>
      </svg>
    </div>
  )
}
export function BudgetUtilization({ className }) {
  return (
    <div className="-ml-1">
      <svg
        fill="currentColor"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        width="64px"
        height="64px"
        className={className}
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path d="M77,58.48H56.47a1.63,1.63,0,0,0-1.63,1.63h0v1.64a1.65,1.65,0,0,0,1.63,1.64H77a1.65,1.65,0,0,0,1.63-1.64V60.11A1.63,1.63,0,0,0,77,58.48Z"></path>{" "}
          <path d="M77,70H56.47a1.65,1.65,0,0,0-1.63,1.64v1.64a1.63,1.63,0,0,0,1.63,1.63H77a1.63,1.63,0,0,0,1.63-1.63V71.63A1.64,1.64,0,0,0,77,70Z"></path>{" "}
          <path d="M43.55,58.48H23a1.65,1.65,0,0,0-1.64,1.63v1.64A1.66,1.66,0,0,0,23,63.39H43.55a1.66,1.66,0,0,0,1.64-1.64V60.11A1.65,1.65,0,0,0,43.55,58.48Z"></path>{" "}
          <path d="M43.55,70H23a1.66,1.66,0,0,0-1.64,1.64v1.64A1.64,1.64,0,0,0,23,74.9H43.55a1.65,1.65,0,0,0,1.64-1.63V71.63A1.65,1.65,0,0,0,43.55,70Z"></path>{" "}
          <path d="M66.73,25.14a13,13,0,1,0,13,13A13,13,0,0,0,66.73,25.14ZM73.17,39a.82.82,0,0,1-.82.7H61.11a.78.78,0,0,1-.81-.7,11.3,11.3,0,0,1,0-1.84.82.82,0,0,1,.81-.7H72.35a.82.82,0,0,1,.82.7A11.3,11.3,0,0,1,73.17,39Z"></path>{" "}
          <path d="M42.51,28.88A13,13,0,0,0,24.08,47.31h0A13,13,0,0,0,42.51,28.88ZM42,39.17a.51.51,0,0,1-.47.55H35.46a.58.58,0,0,0-.54.54v6a.58.58,0,0,1-.54.54H32.21a.5.5,0,0,1-.54-.46V40.26a.51.51,0,0,0-.48-.54H25.12a.52.52,0,0,1-.54-.5V37a.59.59,0,0,1,.54-.55h6a.51.51,0,0,0,.55-.47V30a.58.58,0,0,1,.54-.54h2.17a.54.54,0,0,1,.54.54h0v6a.5.5,0,0,0,.46.54h6.08A.6.6,0,0,1,42,37Z"></path>{" "}
        </g>
      </svg>
    </div>
  )
}
export function PartnerInventionsIcon(props) {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      className={props.className}
    >
      <path
        d="M3.18861 3.30722C2.95214 3.30722 2.75816 3.50099 2.75816 3.73721V13.4219C2.75816 13.6581 2.95214 13.8519 3.18861 13.8519C3.42508 13.8519 3.61907 13.6581 3.61907 13.4219L3.61722 3.73721C3.61722 3.50099 3.42508 3.30722 3.18861 3.30722Z"
        fill="currentcolor"
      />
      <path
        d="M44.8723 33.0349L41.776 26.0851C41.4398 25.3192 40.5142 24.9612 39.7198 25.2842L37.4346 26.2069C37.041 26.3637 36.7325 26.6719 36.5755 27.0594C36.4462 27.3676 36.4388 27.7035 36.5256 28.019C36.0102 28.2128 35.48 28.3475 34.935 28.4269L34.9331 3.81446C34.9331 1.7107 33.2206 0 31.1145 0H3.18867C1.43363 0 0 1.43202 0 3.18519V14.752C0 16.0771 1.08261 17.1566 2.40718 17.1566L5.5164 17.1584V33.1562C5.5164 35.2599 7.22897 36.9706 9.33503 36.9706H21.2806C21.2954 37.0426 21.3231 37.1072 21.3379 37.1847C21.3878 37.528 21.5817 37.8583 21.8976 38.1L22.3484 38.4433L21.7258 39.1943C21.4598 39.5099 21.3453 39.903 21.397 40.296C21.4469 40.6965 21.6556 41.0545 21.9845 41.2981C22.2431 41.4919 22.5498 41.5915 22.8509 41.6063C22.8361 41.7281 22.8288 41.8499 22.8435 41.9717C22.8934 42.3721 23.0948 42.7301 23.4236 42.9737C23.7026 43.1878 24.0407 43.2893 24.3769 43.2893C24.5709 43.2893 24.763 43.2468 24.9422 43.1823C25.0346 43.4757 25.2138 43.7414 25.4724 43.9407C25.7514 44.1474 26.0895 44.2489 26.4183 44.2489C26.6326 44.2489 26.8414 44.2065 27.0354 44.1197C27.1277 44.3486 27.2718 44.5571 27.4787 44.714C27.7374 44.9077 28.0441 45 28.3452 45C28.7535 45 29.1618 44.8284 29.4407 44.4925L29.7991 44.0552L29.9783 44.1843C30.3145 44.4427 30.7228 44.5848 31.1459 44.5848H31.2457C31.7186 44.5553 32.1343 44.3486 32.4206 44.0053C32.6072 43.7839 32.7218 43.5182 32.7569 43.2321C33.0802 43.4111 33.4441 43.4905 33.8099 43.4609C34.2976 43.4259 34.6985 43.2173 34.9701 42.8889C35.1567 42.6674 35.2786 42.3943 35.3137 42.1083C35.6296 42.2873 35.9936 42.3666 36.3668 42.3445C36.8397 42.3094 37.2554 42.1009 37.5344 41.765C37.721 41.5362 37.8355 41.2704 37.8706 40.9844C38.1865 41.1561 38.5505 41.2428 38.9237 41.2206C39.3966 41.1856 39.8123 40.977 40.0913 40.6412C40.3628 40.3127 40.4774 39.8975 40.4275 39.4748C40.3702 39.0098 40.1042 38.5798 39.7107 38.2864L37.9058 36.9559L37.9132 36.9485C38.3639 36.4041 38.9514 35.9612 39.6257 35.6604L39.9195 35.5312C40.2206 35.8818 40.6713 36.0904 41.1369 36.0904C41.3383 36.0904 41.5452 36.0553 41.7466 35.9759L44.0245 35.0532C44.4254 34.8964 44.7265 34.5882 44.8835 34.2007C45.0442 33.8131 45.0368 33.3998 44.8724 33.0343L44.8723 33.0349ZM5.51643 16.2988H2.40722C1.5537 16.2988 0.859089 15.6049 0.859089 14.7523V3.18548C0.859089 1.90478 1.90472 0.858406 3.18871 0.858406C4.47081 0.858406 5.51833 1.90289 5.51833 3.18548L5.51643 16.2988ZM9.34434 36.1128C7.71122 36.1128 6.38476 34.7878 6.38476 33.1564V3.18529C6.38476 2.26997 5.99125 1.44506 5.36684 0.858217H31.12C32.7457 0.858217 34.0722 2.18323 34.0722 3.80719V28.4805C33.7636 28.4879 33.4496 28.4805 33.141 28.451L30.1242 28.1502C29.1432 28.0579 28.1604 28.3643 27.4362 28.988L27.1498 29.239L26.978 29.2611C26.2113 29.3183 25.4668 29.1689 24.835 28.8238L24.4914 28.6448L24.5708 28.5156C24.7925 28.1723 24.8646 27.7645 24.7648 27.3696C24.6724 26.9691 24.4138 26.6259 24.048 26.41L21.9198 25.1643C21.1882 24.7344 20.222 24.9577 19.7694 25.6589L15.6201 32.1014C15.3984 32.4446 15.3263 32.8525 15.4261 33.2474C15.5184 33.6479 15.7771 33.9911 16.1429 34.1996L18.2711 35.4453C18.5224 35.5947 18.8013 35.6593 19.0803 35.6593C19.4534 35.6593 19.8192 35.5302 20.1056 35.2939L20.2552 35.4084C20.5139 35.6021 20.7282 35.831 20.9 36.0819L9.34413 36.0838L9.34434 36.1128ZM23.8466 28.0669L19.7047 34.502C19.7047 34.5094 19.6973 34.5168 19.6973 34.5168C19.4904 34.825 19.0525 34.9173 18.7218 34.7235L16.5936 33.4778C16.4366 33.3856 16.322 33.2342 16.2777 33.0626C16.2426 32.8984 16.2703 32.7341 16.3645 32.5902L20.5138 26.1477C20.6505 25.941 20.8796 25.8248 21.1235 25.8248C21.2528 25.8248 21.3822 25.8598 21.5041 25.9244L23.6323 27.1701C23.7894 27.2624 23.9039 27.4137 23.9482 27.5853C23.9686 27.7514 23.9409 27.923 23.8466 28.0669ZM22.5073 40.614C22.3632 40.507 22.2782 40.3631 22.2634 40.1988C22.2412 40.042 22.293 39.8759 22.4075 39.7485L23.5972 38.3239C23.7339 38.1596 23.9335 38.0803 24.1348 38.0803C24.2845 38.0803 24.436 38.1227 24.5653 38.2169C24.7445 38.3608 24.8369 38.5675 24.8091 38.7889C24.7944 38.9107 24.7519 39.003 24.6798 39.0897L23.4901 40.5217C23.2388 40.8004 22.8084 40.8503 22.5073 40.614ZM24.9144 42.1974C24.678 42.4835 24.2475 42.5259 23.9464 42.2971C23.8097 42.1974 23.7247 42.0461 23.7025 41.8819C23.6804 41.7176 23.7321 41.5589 23.8392 41.4316L25.6313 39.2835C25.768 39.1193 25.9601 39.0325 26.1688 39.0325C26.3185 39.0325 26.4774 39.0824 26.6067 39.1765C26.7859 39.313 26.8783 39.5197 26.8432 39.7412C26.8284 39.8556 26.7859 39.9552 26.7138 40.042L24.9144 42.1974ZM26.9632 43.1478C26.7268 43.4264 26.2963 43.4763 25.9952 43.2548C25.8511 43.1478 25.7661 42.9965 25.7513 42.8396C25.7291 42.6828 25.7809 42.5167 25.888 42.3893C25.8954 42.3746 25.9102 42.3598 25.9176 42.3543L27.0648 40.972L27.0722 40.9647C27.0796 40.9573 27.087 40.9499 27.1018 40.9425C27.3456 40.6768 27.7613 40.6417 28.0477 40.8558C28.2343 40.9923 28.3266 41.2064 28.2915 41.4205C28.2768 41.5275 28.2269 41.6345 28.1548 41.7213L26.9632 43.1478ZM29.4942 42.9836C29.4795 43.0629 29.4517 43.133 29.4019 43.1976C29.4019 43.1976 29.4019 43.205 29.3945 43.205C29.3871 43.2124 28.7922 43.9432 28.7922 43.9432C28.6056 44.1646 28.2546 44.2015 28.0108 44.0225C27.9036 43.9358 27.8316 43.8214 27.8168 43.694C27.802 43.5722 27.839 43.4431 27.9313 43.3434L28.5188 42.6274C28.5262 42.62 28.5336 42.6126 28.541 42.5979C28.735 42.3838 29.0712 42.3469 29.3077 42.5259C29.4444 42.6477 29.5146 42.8119 29.4942 42.9836ZM39.2023 38.9827C39.4092 39.1322 39.5459 39.3554 39.5755 39.5843C39.5977 39.7706 39.5459 39.957 39.4314 40.0991C39.2947 40.2634 39.1081 40.3501 38.8716 40.3704C38.685 40.3778 38.4282 40.3556 38.1696 40.1637L37.1664 39.4052H37.159L34.0923 37.0929C33.8983 36.949 33.6341 36.9859 33.49 37.1797C33.3459 37.3734 33.3829 37.6373 33.5769 37.7813L36.651 40.101C36.8579 40.2578 36.9946 40.4867 37.0242 40.7173C37.039 40.8539 37.0242 41.0532 36.8745 41.2322C36.7452 41.3817 36.5457 41.4832 36.3092 41.5035C36.0506 41.5182 35.8067 41.4463 35.6072 41.2894L34.6188 40.5512C34.6114 40.5512 34.6114 40.5438 34.6114 40.5365L32.5405 38.9752C32.3465 38.8313 32.0823 38.8682 31.9382 39.062C31.7941 39.2557 31.8311 39.5196 32.0251 39.6636L34.0813 41.2174C34.0887 41.2248 34.0887 41.2322 34.0961 41.2396L34.1034 41.2469C34.1958 41.3189 34.2752 41.3964 34.3325 41.4905C34.3898 41.5773 34.4323 41.6695 34.4545 41.7692C34.484 41.8984 34.5043 42.142 34.3177 42.3634C34.1607 42.5572 33.9242 42.6144 33.7524 42.6291C33.5086 42.6513 33.2647 42.5793 33.0652 42.4225L32.062 41.664C32.062 41.664 32.0547 41.664 32.0547 41.6566L30.9942 40.8557C30.8002 40.7118 30.5361 40.7487 30.392 40.9424C30.2479 41.1362 30.2848 41.4001 30.4788 41.544L31.5466 42.3523H31.554C31.7609 42.5091 31.8976 42.7324 31.9272 42.9613C31.942 43.0978 31.9272 43.2898 31.7775 43.4761C31.6482 43.633 31.4487 43.7345 31.2251 43.7474C30.9813 43.7622 30.73 43.6828 30.5305 43.526L30.3088 43.3617C30.3384 43.2824 30.3587 43.2049 30.3661 43.1181C30.4307 42.6383 30.2294 42.1585 29.8359 41.8651C29.6289 41.7083 29.3925 41.6215 29.1486 41.5938C29.1486 41.5791 29.156 41.5643 29.156 41.5514C29.2281 41.0291 29.0064 40.4995 28.5759 40.1765C28.3173 39.9828 28.0161 39.8905 27.7095 39.8757C27.7815 39.3535 27.5598 38.8312 27.1368 38.5083C26.6934 38.1724 26.1041 38.1152 25.6182 38.3016C25.5258 38.0082 25.3466 37.7425 25.0954 37.5431C24.4284 37.0486 23.4696 37.1574 22.945 37.7867L22.9302 37.8015L22.4499 37.4435C22.3704 37.3863 22.2429 37.2571 22.2208 37.0928C22.1857 36.8566 22.1284 36.6278 22.049 36.4193C21.8125 35.7678 21.382 35.2032 20.8093 34.7732L20.6652 34.6661L24.0479 29.4123L24.4635 29.6263C24.9864 29.905 25.5664 30.0766 26.1835 30.1412L25.9544 30.3423C25.1452 31.0436 24.7499 32.0752 24.9013 33.0975L25.16 34.9725C25.2246 35.3951 25.6182 35.6885 26.0338 35.6313C26.7285 35.5519 27.3455 35.2161 27.7815 34.6864C28.0679 34.3432 28.2544 33.9354 28.3339 33.4906L28.4706 32.6602C28.5279 32.3373 28.7644 32.0807 29.1006 31.9811C29.2798 31.9239 29.5015 31.9091 29.7028 31.9737L39.2023 38.9827ZM39.2744 34.8674C38.4855 35.2254 37.7835 35.7477 37.2533 36.3918L37.2182 36.4342L30.6192 31.5455C30.1888 31.0805 29.5089 30.9236 28.8272 31.1229C28.1751 31.3167 27.7095 31.8389 27.595 32.483L27.4582 33.3134C27.4084 33.5995 27.2864 33.8726 27.0925 34.1014C26.8135 34.4373 26.4181 34.6606 25.9674 34.7307L25.7161 32.9406C25.609 32.2025 25.8953 31.4662 26.4828 30.9587L27.6079 29.9917C27.6153 29.9843 27.6227 29.9843 27.6227 29.9769L28.0032 29.654C28.5482 29.1815 29.2928 28.9453 30.0391 29.0173L33.056 29.3181C34.3602 29.4473 35.6645 29.2683 36.8617 28.8032L39.5128 34.7582L39.2744 34.8674ZM44.0908 33.8654C44.0188 34.037 43.8839 34.1662 43.7047 34.2381L41.4268 35.1608C41.0536 35.3103 40.6306 35.1535 40.4809 34.8028L37.4863 28.067L37.3939 27.8529C37.3218 27.6961 37.3218 27.5244 37.3865 27.3731C37.4585 27.2015 37.5934 27.0723 37.7726 27.0003L40.0579 26.0777C40.1502 26.0426 40.2519 26.0204 40.3442 26.0204C40.6232 26.0204 40.8892 26.1773 41.0037 26.4283L44.1 33.3781C44.1555 33.535 44.1555 33.7067 44.0908 33.8654Z"
        fill="currentcolor"
      />
      <path
        d="M11.2636 10.1502H28.9271C29.9229 10.1502 30.7394 9.34189 30.7394 8.33983L30.7412 4.80401C30.7412 3.80932 29.9321 2.99367 28.9289 2.99367L11.2636 2.99183C10.2678 2.99183 9.45127 3.8001 9.45127 4.80216V8.33061C9.45127 9.33452 10.2605 10.1502 11.2636 10.1502ZM10.3104 4.8042C10.3104 4.28193 10.7334 3.85198 11.2636 3.85198H28.9271C29.4499 3.85198 29.8803 4.27458 29.8803 4.8042V8.33265C29.8803 8.85491 29.4573 9.28487 28.9271 9.28487H11.2636C10.7408 9.28487 10.3104 8.86227 10.3104 8.33265V4.8042Z"
        fill="currentcolor"
      />
      <path
        d="M16.5161 12.4622C16.2797 12.4622 16.0857 12.656 16.0857 12.8922C16.0857 13.1284 16.2797 13.3222 16.5161 13.3222H30.7266C30.9631 13.3222 31.1571 13.1284 31.1571 12.8922C31.1571 12.656 30.9631 12.4622 30.7266 12.4622H16.5161Z"
        fill="currentcolor"
      />
      <path
        d="M30.7266 15.6402H16.5161C16.2797 15.6402 16.0857 15.834 16.0857 16.0702C16.0857 16.3064 16.2797 16.5002 16.5161 16.5002H30.7266C30.9631 16.5002 31.1571 16.3064 31.1571 16.0702C31.1571 15.834 30.9631 15.6402 30.7266 15.6402Z"
        fill="currentcolor"
      />
      <path
        d="M30.7266 18.8126H16.5161C16.2797 18.8126 16.0857 19.0063 16.0857 19.2425C16.0857 19.4787 16.2797 19.6725 16.5161 19.6725H30.7266C30.9631 19.6725 31.1571 19.4787 31.1571 19.2425C31.1571 19.0045 30.9631 18.8126 30.7266 18.8126Z"
        fill="currentcolor"
      />
      <path
        d="M30.7266 21.9901H16.5161C16.2797 21.9901 16.0857 22.1839 16.0857 22.4201C16.0857 22.6563 16.2797 22.85 16.5161 22.85H30.7266C30.9631 22.85 31.1571 22.6563 31.1571 22.4201C31.1571 22.182 30.9631 21.9901 30.7266 21.9901Z"
        fill="currentcolor"
      />
      <path
        d="M13.1057 25.6476H8.58323C8.34676 25.6476 8.15278 25.8414 8.15278 26.0776C8.15278 26.3138 8.34676 26.5076 8.58323 26.5076H13.1057C13.3422 26.5076 13.5362 26.3138 13.5362 26.0776C13.5362 25.8414 13.3422 25.6476 13.1057 25.6476Z"
        fill="currentcolor"
      />
      <path
        d="M13.1057 28.8256H8.58323C8.34676 28.8256 8.15278 29.0194 8.15278 29.2556C8.15278 29.4918 8.34676 29.6856 8.58323 29.6856H13.1057C13.3422 29.6856 13.5362 29.4918 13.5362 29.2556C13.5362 29.0194 13.3422 28.8256 13.1057 28.8256Z"
        fill="currentcolor"
      />
      <path
        d="M13.1057 32.0031H8.58323C8.34676 32.0031 8.15278 32.1969 8.15278 32.4331C8.15278 32.6693 8.34676 32.8631 8.58323 32.8631H13.1057C13.3422 32.8631 13.5362 32.6693 13.5362 32.4331C13.5362 32.1969 13.3422 32.0031 13.1057 32.0031Z"
        fill="currentcolor"
      />
      <path
        d="M12.9837 5.93518H27.2368C27.4733 5.93518 27.6672 5.74141 27.6672 5.5052C27.6672 5.26899 27.4733 5.07522 27.2368 5.07522H12.9837C12.7472 5.07522 12.5533 5.26899 12.5533 5.5052C12.5533 5.74141 12.7472 5.93518 12.9837 5.93518Z"
        fill="currentcolor"
      />
      <path
        d="M12.9837 8.06677H23.8614C24.0979 8.06677 24.2918 7.873 24.2918 7.63678C24.2918 7.40057 24.0979 7.2068 23.8614 7.2068L12.9837 7.20865C12.7472 7.20865 12.5533 7.40242 12.5533 7.63863C12.5533 7.87484 12.7472 8.06677 12.9837 8.06677Z"
        fill="currentcolor"
      />
    </svg>
  )
}

export function RequisitionsIcon(props) {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      className={props.className}
    >
      <path
        d="M33.1739 25.6543C33.1739 25.4839 33.3139 25.3457 33.4867 25.3457C33.6595 25.3457 33.7996 25.4839 33.7996 25.6543V43.0468C33.7996 43.5843 33.5769 44.0727 33.2181 44.4265C32.8594 44.7804 32.3643 45 31.8194 45H1.98016C1.43529 45 0.940178 44.7804 0.581432 44.4265C0.222679 44.0726 0 43.5843 0 43.0468V1.95316C0 1.41572 0.222679 0.927356 0.581432 0.573503C0.940178 0.219642 1.43529 0 1.98016 0H31.8194C32.3643 0 32.8594 0.219642 33.2181 0.573503C33.5769 0.927356 33.7996 1.41572 33.7996 1.95316V13.1227C33.7996 13.2931 33.6595 13.4313 33.4867 13.4313C33.3139 13.4313 33.1739 13.2931 33.1739 13.1227V1.95316C33.1739 1.58608 33.0214 1.25215 32.7757 1.00986C32.5301 0.767564 32.1915 0.617168 31.8194 0.617168H1.98016C1.60801 0.617168 1.26946 0.767564 1.02382 1.00986C0.778176 1.25215 0.625701 1.58608 0.625701 1.95316V43.0468C0.625701 43.4139 0.778176 43.7479 1.02382 43.9901C1.26946 44.2324 1.60801 44.3828 1.98016 44.3828H31.8194C32.1916 44.3828 32.5301 44.2324 32.7757 43.9902C33.0214 43.7479 33.1739 43.4139 33.1739 43.0468V25.6543ZM11.154 35.6581C11.3268 35.6581 11.4668 35.7963 11.4668 35.9667C11.4668 36.1372 11.3268 36.2753 11.154 36.2753H2.53877C2.36599 36.2753 2.22591 36.1372 2.22591 35.9667C2.22591 35.7963 2.36599 35.6581 2.53877 35.6581H11.154ZM13.0016 33.468C13.1744 33.468 13.3144 33.6062 13.3144 33.7766C13.3144 33.947 13.1744 34.0852 13.0016 34.0852H2.53877C2.36599 34.0852 2.22591 33.947 2.22591 33.7766C2.22591 33.6062 2.36599 33.468 2.53877 33.468H13.0016ZM14.8492 31.2779C15.022 31.2779 15.162 31.416 15.162 31.5865C15.162 31.7569 15.022 31.895 14.8492 31.895H2.53877C2.36599 31.895 2.22591 31.7569 2.22591 31.5865C2.22591 31.416 2.36599 31.2779 2.53877 31.2779H14.8492ZM16.6968 29.0877C16.8696 29.0877 17.0096 29.2259 17.0096 29.3963C17.0096 29.5668 16.8696 29.7049 16.6968 29.7049H2.53877C2.36599 29.7049 2.22591 29.5668 2.22591 29.3963C2.22591 29.2259 2.36599 29.0877 2.53877 29.0877H16.6968ZM18.5444 26.8976C18.7171 26.8976 18.8572 27.0358 18.8572 27.2062C18.8572 27.3766 18.7171 27.5148 18.5444 27.5148H2.53877C2.36599 27.5148 2.22591 27.3766 2.22591 27.2062C2.22591 27.0358 2.36599 26.8976 2.53877 26.8976H18.5444ZM20.392 24.7075C20.5647 24.7075 20.7048 24.8456 20.7048 25.0161C20.7048 25.1865 20.5647 25.3246 20.392 25.3246H2.53877C2.36599 25.3246 2.22591 25.1865 2.22591 25.0161C2.22591 24.8456 2.36599 24.7075 2.53877 24.7075H20.392ZM22.2396 22.5173C22.4123 22.5173 22.5524 22.6555 22.5524 22.8259C22.5524 22.9964 22.4123 23.1345 22.2396 23.1345H2.53877C2.36599 23.1345 2.22591 22.9964 2.22591 22.8259C2.22591 22.6555 2.36599 22.5173 2.53877 22.5173H22.2396ZM7.88721 10.1983C8.21049 10.7779 8.63041 11.4866 9.04793 12.0447C9.42664 12.5509 9.78196 12.9275 10.0013 12.925C10.2869 12.9219 11.157 11.963 12.1318 10.693C13.1892 9.31535 14.3178 7.59072 14.9611 6.27385C15.036 6.12073 15.2226 6.05651 15.3779 6.1304C15.4 6.14096 15.4203 6.15376 15.4387 6.16839L17.4299 7.62455C17.5683 7.72573 17.5972 7.9184 17.4947 8.05487C16.9292 8.80887 15.3142 10.7013 13.8214 12.3633C12.6086 13.7136 11.4695 14.9179 11.0225 15.2528C10.7794 15.4349 10.5297 15.5415 10.2788 15.5808C10.0089 15.6231 9.74396 15.5883 9.48961 15.4862C8.98166 15.2825 8.28271 14.515 7.63099 13.6765C6.99867 12.8629 6.40609 11.9838 6.09291 11.5121C6.00456 11.3788 6.03423 11.2032 6.15653 11.1047L6.15646 11.1046L7.40799 10.0944C7.54163 9.98659 7.73861 10.006 7.84795 10.1378C7.86371 10.1568 7.87676 10.1771 7.88721 10.1983ZM8.54689 12.4111C8.17972 11.9204 7.81759 11.3316 7.51515 10.8049L6.77043 11.406C7.09993 11.897 7.60335 12.6288 8.12716 13.3028C8.72207 14.0682 9.33753 14.7597 9.72425 14.9149C9.87575 14.9756 10.0293 14.9971 10.181 14.9733C10.3327 14.9495 10.4886 14.8814 10.6461 14.7634C11.0562 14.4562 12.1635 13.2819 13.3546 11.9559C14.6933 10.4654 16.129 8.79089 16.8047 7.93326L15.3556 6.8735C14.6778 8.17542 13.6221 9.77226 12.6304 11.0642C11.5505 12.4711 10.5019 13.5343 10.0062 13.5398C9.54857 13.5449 9.03353 13.0616 8.54689 12.4111ZM9.82364 41.5404V40.9232H10.4493V41.5404H9.82364ZM2.31523 41.5404V40.9232H2.94093V41.5404H2.31523ZM4.81804 41.5404V40.9232H5.44374V41.5404H4.81804ZM7.32083 41.5404V40.9232H7.94653V41.5404H7.32083ZM15.9497 39.8391L13.0597 41.1404C12.3634 41.4539 12.1882 41.3003 12.0221 41.1547C12.017 41.1502 12.012 41.1456 12.0073 41.1408C11.8847 41.032 11.8079 40.8934 11.8089 40.6811C11.8096 40.5296 11.8562 40.3386 11.9677 40.0814L13.2002 37.2413C13.0584 36.9845 12.9875 36.6991 12.9875 36.4138C12.9875 35.9717 13.1577 35.5293 13.4982 35.1935L40.1759 8.87959C40.5164 8.54373 40.9649 8.37579 41.4131 8.37579C41.8613 8.37579 42.3098 8.54373 42.6503 8.87959L44.4892 10.6935C44.8297 11.0293 45 11.4717 45 11.9138C45 12.3559 44.8297 12.7983 44.4892 13.1341L17.8116 39.448C17.4711 39.7838 17.0226 39.9518 16.5744 39.9518C16.3624 39.9518 16.1503 39.9142 15.9497 39.8391ZM12.8007 40.5811L15.3308 39.4417L13.6456 37.7795L12.5421 40.3225C12.4647 40.5009 12.4324 40.6138 12.4321 40.6835C12.4321 40.6867 12.4276 40.6846 12.4252 40.6835L12.4247 40.6835C12.4291 40.6869 12.4334 40.6905 12.4376 40.6942C12.456 40.7104 12.4755 40.7275 12.8007 40.5811ZM12.424 40.683L12.4247 40.6835L12.4252 40.6835L12.424 40.683ZM43.8674 12.8747C43.5446 12.6297 43.1896 12.4392 42.8421 12.402C42.5427 12.37 42.237 12.4591 41.9485 12.7437L38.9122 15.7385C38.7901 15.859 38.592 15.859 38.4699 15.7385C38.3477 15.618 38.3477 15.4226 38.4699 15.3022L41.5061 12.3073C41.5189 12.2947 41.5317 12.2824 41.5446 12.2703C41.863 11.9345 41.9183 11.5798 41.8266 11.2376C41.7217 10.8463 41.4373 10.4562 41.1167 10.1142L41.0291 10.0207L41.0287 10.0211C41.0483 10.0422 41.0636 10.0586 41.0286 10.0211C40.8897 9.87214 40.66 9.62584 40.4867 9.44575L13.9406 35.6298C13.7223 35.8451 13.6132 36.1293 13.6132 36.4138C13.6132 36.6982 13.7223 36.9824 13.9406 37.1977L15.7796 39.0116C15.9979 39.2269 16.286 39.3346 16.5744 39.3346C16.8627 39.3346 17.1509 39.2269 17.3692 39.0116L43.8674 12.8747ZM42.9081 11.7897C43.3902 11.8412 43.8551 12.0871 44.2625 12.3984C44.337 12.2461 44.3743 12.08 44.3743 11.9138C44.3743 11.6294 44.2651 11.3451 44.0469 11.1298L42.2079 9.31594C41.9896 9.10063 41.7014 8.99296 41.4131 8.99296C41.2687 8.99296 41.1243 9.01997 40.9887 9.07397C41.1618 9.25419 41.3619 9.46874 41.4881 9.60407C41.6537 9.78159 41.352 9.46054 41.5738 9.69709C41.9546 10.1035 42.2956 10.5785 42.4303 11.0809C42.4939 11.3182 42.5133 11.5585 42.4732 11.7973C42.6175 11.7757 42.7629 11.7741 42.9081 11.7897ZM41.0291 10.0207C40.972 9.95999 41.0037 9.99425 41.0287 10.0211L41.0291 10.0207ZM16.4752 11.7493C16.4752 11.5788 16.6153 11.4407 16.7881 11.4407C16.9609 11.4407 17.1009 11.5788 17.1009 11.7493C17.1009 13.5978 16.3413 15.2714 15.1131 16.4828C13.8849 17.6942 12.1882 18.4435 10.3142 18.4435C8.44008 18.4435 6.74339 17.6942 5.51521 16.4828C4.28703 15.2714 3.52738 13.5978 3.52738 11.7493C3.52738 9.90075 4.28703 8.22719 5.51521 7.01577C6.74339 5.80434 8.44008 5.05505 10.3142 5.05505C10.7214 5.05505 11.121 5.09065 11.5096 5.15885C11.9074 5.22867 12.2935 5.33277 12.6646 5.46797C12.8266 5.52655 12.9098 5.70357 12.8504 5.86334C12.791 6.02311 12.6115 6.10514 12.4495 6.04656C12.1135 5.92415 11.7634 5.82978 11.4021 5.76638C11.0495 5.70451 10.686 5.67222 10.3142 5.67222C8.61279 5.67222 7.07251 6.35242 5.95759 7.45213C4.84268 8.55183 4.15308 10.0711 4.15308 11.7493C4.15308 13.4274 4.84268 14.9467 5.95759 16.0464C7.07251 17.1461 8.61279 17.8263 10.3142 17.8263C12.0155 17.8263 13.5558 17.1461 14.6707 16.0464C15.7856 14.9467 16.4752 13.4274 16.4752 11.7493Z"
        fill="currentcolor"
      />
    </svg>
  )
}
export function BudgetIcon(props) {
  return (
    <svg
      width="36"
      height="41"
      viewBox="0 0 36 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M26.0108 40.5H0.451092C0.202093 40.5 0 40.2902 0 40.0317V0.96828C0 0.709794 0.20211 0.5 0.451092 0.5H26.0108C26.2598 0.5 26.4619 0.709811 26.4619 0.96828V17.3671C26.4619 17.6256 26.2598 17.8354 26.0108 17.8354C25.7618 17.8354 25.5597 17.6256 25.5597 17.3671V1.43665H0.904005V39.5621H26.0125C26.2615 39.5621 26.4636 39.7719 26.4636 40.0303C26.462 40.2905 26.2598 40.5 26.0108 40.5Z"
        fill="currentcolor"
      />
      <path
        d="M34.7081 40.5H21.9283C21.2168 40.5 20.638 39.8991 20.638 39.1605L20.6396 18.2366C20.6396 17.4981 21.2184 16.8972 21.9299 16.8972H34.7097C35.4212 16.8972 36 17.4981 36 18.2366V39.1588C35.9984 39.8991 35.4196 40.5 34.7081 40.5ZM21.9283 17.8354C21.7148 17.8354 21.5418 18.015 21.5418 18.2365V39.1587C21.5418 39.3803 21.7148 39.5599 21.9283 39.5599H34.7081C34.9215 39.5599 35.0945 39.3803 35.0945 39.1587V18.2365C35.0945 18.015 34.9215 17.8354 34.7081 17.8354H21.9283Z"
        fill="currentcolor"
      />
      <path
        d="M33.4084 23.4248H23.3029C23.0539 23.4248 22.8518 23.215 22.8518 22.9565V19.7405C22.8518 19.482 23.0539 19.2722 23.3029 19.2722H33.4084C33.6574 19.2722 33.8595 19.482 33.8595 19.7405V22.9565C33.8595 23.215 33.6574 23.4248 33.4084 23.4248ZM23.7557 22.4882H32.9572V20.2105L23.7557 20.2088V22.4882Z"
        fill="currentcolor"
      />
      <path
        d="M24.8518 26.9463H23.3028C23.0538 26.9463 22.8517 26.7364 22.8517 26.478C22.8517 26.2195 23.0538 26.0097 23.3028 26.0097H24.8518C25.1008 26.0097 25.3029 26.2195 25.3029 26.478C25.3045 26.7365 25.1008 26.9463 24.8518 26.9463Z"
        fill="currentcolor"
      />
      <path
        d="M29.1301 26.9463H27.5812C27.3322 26.9463 27.1301 26.7364 27.1301 26.478C27.1301 26.2195 27.3322 26.0097 27.5812 26.0097H29.1301C29.3791 26.0097 29.5812 26.2195 29.5812 26.478C29.5812 26.7365 29.3791 26.9463 29.1301 26.9463Z"
        fill="currentcolor"
      />
      <path
        d="M33.4084 26.9463H31.8594C31.6104 26.9463 31.4083 26.7364 31.4083 26.478C31.4083 26.2195 31.6105 26.0097 31.8594 26.0097H33.4084C33.6574 26.0097 33.8595 26.2195 33.8595 26.478C33.8595 26.7365 33.6574 26.9463 33.4084 26.9463Z"
        fill="currentcolor"
      />
      <path
        d="M24.8518 29.8568H23.3028C23.0538 29.8568 22.8517 29.647 22.8517 29.3885C22.8517 29.13 23.0538 28.9202 23.3028 28.9202H24.8518C25.1008 28.9202 25.3029 29.13 25.3029 29.3885C25.3045 29.647 25.1008 29.8568 24.8518 29.8568Z"
        fill="currentcolor"
      />
      <path
        d="M29.1301 29.8568H27.5812C27.3322 29.8568 27.1301 29.647 27.1301 29.3885C27.1301 29.13 27.3322 28.9202 27.5812 28.9202H29.1301C29.3791 28.9202 29.5812 29.13 29.5812 29.3885C29.5812 29.647 29.3791 29.8568 29.1301 29.8568Z"
        fill="currentcolor"
      />
      <path
        d="M33.4084 29.8568H31.8594C31.6104 29.8568 31.4083 29.647 31.4083 29.3885C31.4083 29.13 31.6105 28.9202 31.8594 28.9202H33.4084C33.6574 28.9202 33.8595 29.13 33.8595 29.3885C33.8595 29.647 33.6574 29.8568 33.4084 29.8568Z"
        fill="currentcolor"
      />
      <path
        d="M24.8518 32.7656H23.3028C23.0538 32.7656 22.8517 32.5558 22.8517 32.2973C22.8517 32.0388 23.0538 31.829 23.3028 31.829H24.8518C25.1008 31.829 25.3029 32.0388 25.3029 32.2973C25.3045 32.5558 25.1008 32.7656 24.8518 32.7656Z"
        fill="currentcolor"
      />
      <path
        d="M29.1301 32.7656H27.5812C27.3322 32.7656 27.1301 32.5558 27.1301 32.2973C27.1301 32.0388 27.3322 31.829 27.5812 31.829H29.1301C29.3791 31.829 29.5812 32.0388 29.5812 32.2973C29.5812 32.5558 29.3791 32.7656 29.1301 32.7656Z"
        fill="currentcolor"
      />
      <path
        d="M33.4084 32.7656H31.8594C31.6104 32.7656 31.4083 32.5558 31.4083 32.2973C31.4083 32.0388 31.6105 31.829 31.8594 31.829H33.4084C33.6574 31.829 33.8595 32.0388 33.8595 32.2973C33.8595 32.5558 33.6574 32.7656 33.4084 32.7656Z"
        fill="currentcolor"
      />
      <path
        d="M24.8518 35.6761H23.3028C23.0538 35.6761 22.8517 35.4663 22.8517 35.2078C22.8517 34.9493 23.0538 34.7395 23.3028 34.7395H24.8518C25.1008 34.7395 25.3029 34.9493 25.3029 35.2078C25.3045 35.4663 25.1008 35.6761 24.8518 35.6761Z"
        fill="currentcolor"
      />
      <path
        d="M29.1301 35.6761H27.5812C27.3322 35.6761 27.1301 35.4663 27.1301 35.2078C27.1301 34.9493 27.3322 34.7395 27.5812 34.7395H29.1301C29.3791 34.7395 29.5812 34.9493 29.5812 35.2078C29.5812 35.4663 29.3791 35.6761 29.1301 35.6761Z"
        fill="currentcolor"
      />
      <path
        d="M33.4084 35.6761H31.8594C31.6104 35.6761 31.4083 35.4663 31.4083 35.2078C31.4083 34.9493 31.6105 34.7395 31.8594 34.7395H33.4084C33.6574 34.7395 33.8595 34.9493 33.8595 35.2078C33.8595 35.4663 33.6574 35.6761 33.4084 35.6761Z"
        fill="currentcolor"
      />
      <path
        d="M24.8518 38.5849H23.3028C23.0538 38.5849 22.8517 38.3751 22.8517 38.1166C22.8517 37.8582 23.0538 37.6483 23.3028 37.6483H24.8518C25.1008 37.6483 25.3029 37.8582 25.3029 38.1166C25.3045 38.3751 25.1008 38.5849 24.8518 38.5849Z"
        fill="currentcolor"
      />
      <path
        d="M29.1301 38.5849H27.5812C27.3322 38.5849 27.1301 38.3751 27.1301 38.1166C27.1301 37.8582 27.3322 37.6483 27.5812 37.6483H29.1301C29.3791 37.6483 29.5812 37.8582 29.5812 38.1166C29.5812 38.3751 29.3791 38.5849 29.1301 38.5849Z"
        fill="currentcolor"
      />
      <path
        d="M33.4084 38.5849H31.8594C31.6104 38.5849 31.4083 38.3751 31.4083 38.1166C31.4083 37.8582 31.6105 37.6483 31.8594 37.6483H33.4084C33.6574 37.6483 33.8595 37.8582 33.8595 38.1166C33.8595 38.3751 33.6574 38.5849 33.4084 38.5849Z"
        fill="currentcolor"
      />
      <path
        d="M7.06271 37.4588H3.69153C3.44253 37.4588 3.24043 37.249 3.24043 36.9906L3.23882 27.8694C3.23882 27.611 3.44093 27.4012 3.68991 27.4012H7.06271C7.31171 27.4012 7.5138 27.611 7.5138 27.8694V36.9906C7.51542 37.249 7.31331 37.4588 7.06271 37.4588ZM4.14262 36.5222H6.61158V28.3379H4.14262V36.5222Z"
        fill="currentcolor"
      />
      <path
        d="M12.2996 37.4587H8.92679C8.67779 37.4587 8.4757 37.2489 8.4757 36.9904V24.2758C8.4757 24.0173 8.67781 23.8075 8.92679 23.8075H12.2996C12.5486 23.8075 12.7507 24.0173 12.7507 24.2758V36.9904C12.7507 37.2489 12.5486 37.4587 12.2996 37.4587ZM9.37788 36.5221H11.8468L11.8485 24.7459H9.3795L9.37788 36.5221Z"
        fill="currentcolor"
      />
      <path
        d="M17.5354 37.4586H14.1626C13.9136 37.4586 13.7115 37.2488 13.7115 36.9903V21.2361C13.7115 20.9776 13.9136 20.7678 14.1626 20.7678H17.5354C17.7844 20.7678 17.9865 20.9776 17.9865 21.2361V36.9903C17.9881 37.2488 17.786 37.4586 17.5354 37.4586ZM14.6153 36.522H17.0842V21.7045H14.6153V36.522Z"
        fill="currentcolor"
      />
      <path
        d="M9.59302 16.3618C6.18785 16.3618 3.41647 13.4866 3.41647 9.94995C3.41647 6.41504 6.18619 3.53807 9.59302 3.53807C12.9982 3.53807 15.7696 6.41332 15.7696 9.94995C15.7679 13.4849 12.9982 16.3618 9.59302 16.3618ZM9.59302 4.47652C6.68588 4.47652 4.32048 6.93213 4.32048 9.94995C4.32048 12.9679 6.68596 15.4234 9.59302 15.4234C12.5002 15.4234 14.8656 12.9678 14.8656 9.94995C14.8656 6.93204 12.5001 4.47652 9.59302 4.47652Z"
        fill="currentcolor"
      />
      <path
        d="M13.0323 9.26004V9.93144H6.40952V9.26004H13.0323ZM13.0323 10.7103V11.3817H6.40952V10.7103H13.0323ZM12.4577 6.74902V13.6241H11.3863L8.25026 8.94113H8.19832V13.6241H6.99064V6.74902H8.0717L11.198 11.4354H11.2597V6.74902H12.4577Z"
        fill="currentcolor"
      />
      <path
        d="M22.5947 7.2412H17.8913C17.6423 7.2412 17.4402 7.03139 17.4402 6.77292C17.4402 6.51443 17.6423 6.30464 17.8913 6.30464H22.5947C22.8437 6.30464 23.0458 6.51445 23.0458 6.77292C23.0458 7.03141 22.8437 7.2412 22.5947 7.2412Z"
        fill="currentcolor"
      />
      <path
        d="M22.5947 9.35903H17.8913C17.6423 9.35903 17.4402 9.14922 17.4402 8.89075C17.4402 8.63229 17.6423 8.42247 17.8913 8.42247H22.5947C22.8437 8.42247 23.0458 8.63229 23.0458 8.89075C23.0458 9.14922 22.8437 9.35903 22.5947 9.35903Z"
        fill="currentcolor"
      />
      <path
        d="M22.5947 11.479H17.8913C17.6423 11.479 17.4402 11.2692 17.4402 11.0107C17.4402 10.7522 17.6423 10.5424 17.8913 10.5424H22.5947C22.8437 10.5424 23.0458 10.7522 23.0458 11.0107C23.0458 11.2692 22.8437 11.479 22.5947 11.479Z"
        fill="currentcolor"
      />
      <path
        d="M22.5947 13.5976H17.8913C17.6423 13.5976 17.4402 13.3878 17.4402 13.1294C17.4402 12.8709 17.6423 12.6611 17.8913 12.6611H22.5947C22.8437 12.6611 23.0458 12.8709 23.0458 13.1294C23.0458 13.3878 22.8437 13.5976 22.5947 13.5976Z"
        fill="currentcolor"
      />
    </svg>
  )
}
export function ChevronDown(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={props.style}
    >
      <path
        d="M7.99983 9.45842L7.50485 8.96345L4.87053 6.32912C4.8705 6.3291 4.87048 6.32907 4.87045 6.32905C4.85171 6.31035 4.82631 6.29985 4.79983 6.29985C4.77331 6.29985 4.74788 6.31038 4.72913 6.32912L7.99983 9.45842ZM7.99983 9.45842L8.4948 8.96345M7.99983 9.45842L8.4948 8.96345M8.4948 8.96345L11.1292 6.32905L11.1293 6.32912M8.4948 8.96345L11.1293 6.32912M11.1293 6.32912L11.1377 6.32037M11.1293 6.32912L11.1377 6.32037M11.1377 6.32037C11.147 6.31082 11.158 6.3032 11.1702 6.29796C11.1824 6.29272 11.1955 6.28996 11.2088 6.28985C11.2221 6.28973 11.2352 6.29226 11.2475 6.29729C11.2598 6.30232 11.271 6.30974 11.2804 6.31913C11.2898 6.32852 11.2972 6.33969 11.3022 6.35198L11.9309 6.09476M11.1377 6.32037L11.9309 6.09476M11.9309 6.09476L11.3022 6.35198C11.3072 6.36427 11.3098 6.37744 11.3097 6.39071C11.3095 6.40399 11.3068 6.41711 11.3015 6.42931C11.2963 6.44151 11.2887 6.45255 11.2791 6.46177L11.2791 6.4617M11.9309 6.09476L11.2791 6.4617M11.2791 6.4617L11.2705 6.4703M11.2791 6.4617L11.2705 6.4703M11.2705 6.4703L8.07053 9.67022M11.2705 6.4703L8.07053 9.67022M8.07053 9.67022C8.05178 9.68897 8.02635 9.6995 7.99983 9.6995C7.97331 9.6995 7.94788 9.68897 7.92913 9.67022L4.72928 6.47037C4.72925 6.47035 4.72923 6.47032 4.7292 6.4703L8.07053 9.67022Z"
        fill="currentcolor"
        stroke="currentcolor"
        strokeWidth="1.4"
      />
    </svg>
  )
}
export function PrinterIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.04163 5.83366H13.9583V4.16699C13.9583 2.50033 13.3333 1.66699 11.4583 1.66699H8.54163C6.66663 1.66699 6.04163 2.50033 6.04163 4.16699V5.83366Z"
        stroke="#2A3F54"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 12.5V15.8333C13.3333 17.5 12.5 18.3333 10.8333 18.3333H9.16663C7.49996 18.3333 6.66663 17.5 6.66663 15.8333V12.5H13.3333Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 8.33301V12.4997C17.5 14.1663 16.6667 14.9997 15 14.9997H13.3333V12.4997H6.66667V14.9997H5C3.33333 14.9997 2.5 14.1663 2.5 12.4997V8.33301C2.5 6.66634 3.33333 5.83301 5 5.83301H15C16.6667 5.83301 17.5 6.66634 17.5 8.33301Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 12.5H13.1584H5.83337"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83337 9.16699H8.33337"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function CopyIcon() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66671 5.37467V7.12468C6.66671 8.58301 6.08337 9.16634 4.62504 9.16634H2.87504C1.41671 9.16634 0.833374 8.58301 0.833374 7.12468V5.37467C0.833374 3.91634 1.41671 3.33301 2.87504 3.33301H4.62504C6.08337 3.33301 6.66671 3.91634 6.66671 5.37467Z"
        stroke="#BFBFBF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16671 2.87467V4.62467C9.16671 6.08301 8.58337 6.66634 7.12504 6.66634H6.66671V5.37467C6.66671 3.91634 6.08337 3.33301 4.62504 3.33301H3.33337V2.87467C3.33337 1.41634 3.91671 0.833008 5.37504 0.833008H7.12504C8.58337 0.833008 9.16671 1.41634 9.16671 2.87467Z"
        stroke="#BFBFBF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function FileDownload(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M7.5 9.16699V14.167L9.16667 12.5003"
        stroke="#2A3F54"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50004 14.1667L5.83337 12.5"
        stroke="#2A3F54"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 8.33366V12.5003C18.3333 16.667 16.6666 18.3337 12.5 18.3337H7.49996C3.33329 18.3337 1.66663 16.667 1.66663 12.5003V7.50033C1.66663 3.33366 3.33329 1.66699 7.49996 1.66699H11.6666"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 8.33366H15C12.5 8.33366 11.6666 7.50033 11.6666 5.00033V1.66699L18.3333 8.33366Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function FilesIcon() {
  return (
    <svg
      width="83"
      height="83"
      viewBox="0 0 83 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.25">
        <path
          d="M39.425 77.9268H26.2833C18.7865 77.9268 13.532 76.2514 10.1401 72.8595C6.74828 69.4676 5.07288 64.2131 5.07288 56.7163V43.5747C5.07288 36.0779 6.74828 30.8234 10.1401 27.4315C13.532 24.0397 18.7865 22.3643 26.2833 22.3643H36.6583C37.662 22.3643 38.502 23.2043 38.502 24.208C38.502 25.2117 37.662 26.0518 36.6583 26.0518H26.2833C20.0405 26.0518 15.5876 27.1512 12.7237 30.0151C9.85981 32.879 8.76038 37.3318 8.76038 43.5747V56.7163C8.76038 62.9592 9.85981 67.4121 12.7237 70.2759C15.5876 73.1398 20.0405 74.2393 26.2833 74.2393H39.425C45.6678 74.2393 50.1207 73.1398 52.9846 70.2759C55.8484 67.4121 56.9479 62.9592 56.9479 56.7163V46.3413C56.9479 45.3376 57.7879 44.4976 58.7916 44.4976C59.7953 44.4976 60.6354 45.3376 60.6354 46.3413V56.7163C60.6354 64.2131 58.96 69.4676 55.5681 72.8595C52.1763 76.2514 46.9217 77.9268 39.425 77.9268Z"
          fill="#292D32"
          stroke="#2A3F54"
          strokeWidth="1.5"
        />
        <path
          d="M58.7917 48.9358H47.725C38.0071 48.9358 34.0646 44.9933 34.0646 35.2754V24.2088C34.0646 23.1713 34.6871 22.2029 35.6554 21.8225C36.6237 21.4075 37.7304 21.6496 38.4912 22.3758L60.6246 44.5092C61.3508 45.2354 61.5929 46.3767 61.1779 47.345C60.7975 48.3133 59.8292 48.9358 58.7917 48.9358ZM39.2521 30.4683V35.2754C39.2521 42.1575 40.8429 43.7483 47.725 43.7483H52.5321L39.2521 30.4683Z"
          fill="#292D32"
        />
        <path
          d="M53.95 9.51074H40.1167C38.6988 9.51074 37.5229 8.33491 37.5229 6.91699C37.5229 5.49908 38.6988 4.32324 40.1167 4.32324H53.95C55.3679 4.32324 56.5438 5.49908 56.5438 6.91699C56.5438 8.33491 55.3679 9.51074 53.95 9.51074Z"
          fill="#292D32"
        />
        <path
          d="M24.2084 19.8857C22.7905 19.8857 21.6146 18.7099 21.6146 17.292C21.6146 10.1332 27.4246 4.32324 34.5834 4.32324H43.6442C45.0621 4.32324 46.238 5.49908 46.238 6.91699C46.238 8.33491 45.0621 9.51074 43.6442 9.51074H34.5834C30.295 9.51074 26.8021 13.0037 26.8021 17.292C26.8021 18.7099 25.6263 19.8857 24.2084 19.8857Z"
          fill="#292D32"
        />
        <path
          d="M66.3655 61.3857C64.9476 61.3857 63.7717 60.2099 63.7717 58.792C63.7717 57.3741 64.9476 56.1982 66.3655 56.1982C70.308 56.1982 73.4896 52.982 73.4896 49.0741V27.667C73.4896 26.2491 74.6655 25.0732 76.0834 25.0732C77.5013 25.0732 78.6771 26.2491 78.6771 27.667V49.0741C78.6771 55.8524 73.1438 61.3857 66.3655 61.3857Z"
          fill="#292D32"
        />
        <path
          d="M76.0834 30.2605H65.7084C56.5092 30.2605 52.7396 26.4909 52.7396 17.2918V6.91677C52.7396 5.87927 53.3621 4.91094 54.3305 4.53052C55.2988 4.11552 56.4055 4.3576 57.1663 5.08385L77.9163 25.8339C78.6425 26.5601 78.8846 27.7014 78.4696 28.6697C78.0892 29.638 77.1209 30.2605 76.0834 30.2605ZM57.9271 13.1764V17.2918C57.9271 23.6205 59.3796 25.073 65.7084 25.073H69.8238L57.9271 13.1764Z"
          fill="#292D32"
        />
      </g>
    </svg>
  )
}

export function UploadFileIcon() {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2207_25108)">
        <path
          d="M3 9.5C3 5.35786 6.35786 2 10.5 2H34.5C38.6421 2 42 5.35786 42 9.5V33.5C42 37.6421 38.6421 41 34.5 41H10.5C6.35786 41 3 37.6421 3 33.5V9.5Z"
          stroke="#2E2E2E"
          shapeRendering="crispEdges"
        />
        <path
          d="M19.167 24.8333L22.5003 21.5M22.5003 21.5L25.8337 24.8333M22.5003 21.5V29M29.167 25.4524C30.1849 24.6117 30.8337 23.3399 30.8337 21.9167C30.8337 19.3854 28.7816 17.3333 26.2503 17.3333C26.0682 17.3333 25.8979 17.2383 25.8054 17.0814C24.7187 15.2374 22.7124 14 20.417 14C16.9652 14 14.167 16.7982 14.167 20.25C14.167 21.9718 14.8632 23.5309 15.9894 24.6613"
          stroke="#8D8D8D"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2207_25108"
          x="0.5"
          y="0.5"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2207_25108"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2207_25108"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
export function DeleteWithButton(props) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      onClick={props.onClick}
    >
      <rect
        x="0.25"
        y="0.5"
        width="24"
        height="24"
        rx="5.33333"
        fill={Colors.buttonError}
        fillOpacity="0.8"
      />
      <g clipPath="url(#clip0_1745_104510)">
        <path
          d="M14.0278 9.83247V9.47691C14.0278 8.97909 14.0278 8.73017 13.9309 8.54003C13.8457 8.37277 13.7097 8.23679 13.5424 8.15157C13.3523 8.05469 13.1034 8.05469 12.6056 8.05469H11.8944C11.3966 8.05469 11.1477 8.05469 10.9576 8.15157C10.7903 8.23679 10.6543 8.37277 10.5691 8.54003C10.4722 8.73017 10.4722 8.97909 10.4722 9.47691V9.83247M11.3611 12.2769V14.4991M13.1389 12.2769V14.4991M8.25 9.83247H16.25M15.3611 9.83247V14.8102C15.3611 15.557 15.3611 15.9303 15.2158 16.2156C15.088 16.4664 14.884 16.6704 14.6331 16.7983C14.3479 16.9436 13.9745 16.9436 13.2278 16.9436H11.2722C10.5255 16.9436 10.1521 16.9436 9.8669 16.7983C9.61602 16.6704 9.41204 16.4664 9.28421 16.2156C9.13889 15.9303 9.13889 15.557 9.13889 14.8102V9.83247"
          stroke="white"
          strokeWidth="0.888889"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1745_104510">
          <rect
            width="10.6667"
            height="10.6667"
            fill="white"
            transform="translate(6.91699 7.16602)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export function BuildingIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M13 22.75H5C2.58 22.75 1.25 21.42 1.25 19V11C1.25 8.58 2.58 7.25 5 7.25H10C10.41 7.25 10.75 7.59 10.75 8V19C10.75 20.58 11.42 21.25 13 21.25C13.41 21.25 13.75 21.59 13.75 22C13.75 22.41 13.41 22.75 13 22.75ZM5 8.75C3.42 8.75 2.75 9.42 2.75 11V19C2.75 20.58 3.42 21.25 5 21.25H9.79999C9.43999 20.66 9.25 19.91 9.25 19V8.75H5Z"
        fill="#292D32"
      />
      <path
        d="M10 8.75H5C4.59 8.75 4.25 8.41 4.25 8V6C4.25 4.48 5.48 3.25 7 3.25H10.11C10.34 3.25 10.56 3.35998 10.7 3.53998C10.84 3.72998 10.89 3.97 10.83 4.19C10.77 4.41 10.75 4.66 10.75 5V8C10.75 8.41 10.41 8.75 10 8.75ZM5.75 7.25H9.25V5C9.25 4.91 9.25 4.83 9.25 4.75H7C6.31 4.75 5.75 5.31 5.75 6V7.25Z"
        fill="#292D32"
      />
      <path
        d="M14 13.75C13.59 13.75 13.25 13.41 13.25 13V8C13.25 7.59 13.59 7.25 14 7.25C14.41 7.25 14.75 7.59 14.75 8V13C14.75 13.41 14.41 13.75 14 13.75Z"
        fill="#292D32"
      />
      <path
        d="M18 13.75C17.59 13.75 17.25 13.41 17.25 13V8C17.25 7.59 17.59 7.25 18 7.25C18.41 7.25 18.75 7.59 18.75 8V13C18.75 13.41 18.41 13.75 18 13.75Z"
        fill="#292D32"
      />
      <path
        d="M18 22.75H14C13.59 22.75 13.25 22.41 13.25 22V18C13.25 17.04 14.04 16.25 15 16.25H17C17.96 16.25 18.75 17.04 18.75 18V22C18.75 22.41 18.41 22.75 18 22.75ZM14.75 21.25H17.25V18C17.25 17.86 17.14 17.75 17 17.75H15C14.86 17.75 14.75 17.86 14.75 18V21.25Z"
        fill="#292D32"
      />
      <path
        d="M6 17.75C5.59 17.75 5.25 17.41 5.25 17V13C5.25 12.59 5.59 12.25 6 12.25C6.41 12.25 6.75 12.59 6.75 13V17C6.75 17.41 6.41 17.75 6 17.75Z"
        fill="#292D32"
      />
      <path
        d="M19 22.75H13C10.58 22.75 9.25 21.42 9.25 19V5C9.25 2.58 10.58 1.25 13 1.25H19C21.42 1.25 22.75 2.58 22.75 5V19C22.75 21.42 21.42 22.75 19 22.75ZM13 2.75C11.42 2.75 10.75 3.42 10.75 5V19C10.75 20.58 11.42 21.25 13 21.25H19C20.58 21.25 21.25 20.58 21.25 19V5C21.25 3.42 20.58 2.75 19 2.75H13Z"
        fill="#292D32"
      />
    </svg>
  )
}
export function UsersIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={props.style}
    >
      <path
        d="M8 2.90267C8.35829 2.49647 8.83179 2.20901 9.35747 2.07853C9.88316 1.94805 10.4361 1.98075 10.9428 2.17227C11.4494 2.36379 11.8857 2.70505 12.1937 3.15064C12.5016 3.59623 12.6665 4.12503 12.6665 4.66667C12.6665 5.20831 12.5016 5.7371 12.1937 6.18269C11.8857 6.62829 11.4494 6.96955 10.9428 7.16107C10.4361 7.35259 9.88316 7.38528 9.35747 7.25481C8.83179 7.12433 8.35829 6.83687 8 6.43067M10 14H2V13.3333C2 12.2725 2.42143 11.2551 3.17157 10.5049C3.92172 9.75476 4.93913 9.33333 6 9.33333C7.06087 9.33333 8.07828 9.75476 8.82843 10.5049C9.57857 11.2551 10 12.2725 10 13.3333V14ZM10 14H14V13.3333C14.0001 12.6311 13.8153 11.9413 13.4643 11.3331C13.1133 10.725 12.6083 10.2199 12.0002 9.86881C11.3922 9.51767 10.7023 9.33279 10.0001 9.33277C9.29795 9.33274 8.60812 9.51757 8 9.86867M8.66667 4.66667C8.66667 5.37391 8.38572 6.05219 7.88562 6.55229C7.38552 7.05238 6.70724 7.33333 6 7.33333C5.29276 7.33333 4.61448 7.05238 4.11438 6.55229C3.61428 6.05219 3.33333 5.37391 3.33333 4.66667C3.33333 3.95942 3.61428 3.28115 4.11438 2.78105C4.61448 2.28095 5.29276 2 6 2C6.70724 2 7.38552 2.28095 7.88562 2.78105C8.38572 3.28115 8.66667 3.95942 8.66667 4.66667Z"
        stroke="#1ABB9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function TicketIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={props.style}
    >
      <path
        d="M10 3.3335V4.66683M10 7.3335V8.66683M10 11.3335V12.6668M3.33333 3.3335C2.97971 3.3335 2.64057 3.47397 2.39052 3.72402C2.14048 3.97407 2 4.31321 2 4.66683V6.66683C2.35362 6.66683 2.69276 6.80731 2.94281 7.05735C3.19286 7.3074 3.33333 7.64654 3.33333 8.00016C3.33333 8.35378 3.19286 8.69292 2.94281 8.94297C2.69276 9.19302 2.35362 9.3335 2 9.3335V11.3335C2 11.6871 2.14048 12.0263 2.39052 12.2763C2.64057 12.5264 2.97971 12.6668 3.33333 12.6668H12.6667C13.0203 12.6668 13.3594 12.5264 13.6095 12.2763C13.8595 12.0263 14 11.6871 14 11.3335V9.3335C13.6464 9.3335 13.3072 9.19302 13.0572 8.94297C12.8071 8.69292 12.6667 8.35378 12.6667 8.00016C12.6667 7.64654 12.8071 7.3074 13.0572 7.05735C13.3072 6.80731 13.6464 6.66683 14 6.66683V4.66683C14 4.31321 13.8595 3.97407 13.6095 3.72402C13.3594 3.47397 13.0203 3.3335 12.6667 3.3335H3.33333Z"
        stroke="#1ABB9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function TerminalIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={props.style}
    >
      <path
        d="M5.33333 5.99984L7.33333 7.99984L5.33333 9.99984M8.66667 9.99984H10.6667M3.33333 13.3332H12.6667C13.0203 13.3332 13.3594 13.1927 13.6095 12.9426C13.8595 12.6926 14 12.3535 14 11.9998V3.99984C14 3.64622 13.8595 3.30708 13.6095 3.05703C13.3594 2.80698 13.0203 2.6665 12.6667 2.6665H3.33333C2.97971 2.6665 2.64057 2.80698 2.39052 3.05703C2.14048 3.30708 2 3.64622 2 3.99984V11.9998C2 12.3535 2.14048 12.6926 2.39052 12.9426C2.64057 13.1927 2.97971 13.3332 3.33333 13.3332Z"
        stroke="#1ABB9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function CirCledArrowLeft() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="55"
        height="55"
        rx="27.5"
        stroke="white"
        strokeOpacity="0.5"
      />
      <path
        d="M35 28H21M21 28L28 35M21 28L28 21"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function CirCledArrowRight() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="55"
        height="55"
        rx="27.5"
        stroke="white"
        strokeOpacity="0.5"
      />
      <path
        d="M21 28H35M35 28L28 21M35 28L28 35"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowDown(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M12 21.25C11.81 21.25 11.62 21.18 11.47 21.03L5.4 14.96C5.11 14.67 5.11 14.19 5.4 13.9C5.69 13.61 6.17 13.61 6.46 13.9L12 19.44L17.54 13.9C17.83 13.61 18.31 13.61 18.6 13.9C18.89 14.19 18.89 14.67 18.6 14.96L12.53 21.03C12.38 21.18 12.19 21.25 12 21.25Z"
        fill="currentcolor"
      />
      <path
        d="M12 21.08C11.59 21.08 11.25 20.74 11.25 20.33V3.5C11.25 3.09 11.59 2.75 12 2.75C12.41 2.75 12.75 3.09 12.75 3.5V20.33C12.75 20.74 12.41 21.08 12 21.08Z"
        fill="currentcolor"
      />
    </svg>
  )
}
export function ArrowUp(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      style={props.style}
    >
      <path
        d="M5.64645 1.14645C5.84171 0.951184 6.15829 0.951184 6.35355 1.14645L8.35355 3.14645C8.54882 3.34171 8.54882 3.65829 8.35355 3.85355C8.15829 4.04882 7.84171 4.04882 7.64645 3.85355L6.5 2.70711V10.5C6.5 10.7761 6.27614 11 6 11C5.72386 11 5.5 10.7761 5.5 10.5V2.70711L4.35355 3.85355C4.15829 4.04882 3.84171 4.04882 3.64645 3.85355C3.45118 3.65829 3.45118 3.34171 3.64645 3.14645L5.64645 1.14645Z"
        fill="#036B26"
      />
    </svg>
  )
}
export function NetbarIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={props.style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3335 1.3335C9.41302 1.3335 8.66683 2.07969 8.66683 3.00016V13.0002C8.66683 13.9206 9.41302 14.6668 10.3335 14.6668H13.0002C13.9206 14.6668 14.6668 13.9206 14.6668 13.0002V3.00016C14.6668 2.07969 13.9206 1.3335 13.0002 1.3335H10.3335ZM10.0002 3.00016C10.0002 2.81607 10.1494 2.66683 10.3335 2.66683H13.0002C13.1843 2.66683 13.3335 2.81607 13.3335 3.00016V13.0002C13.3335 13.1843 13.1843 13.3335 13.0002 13.3335H10.3335C10.1494 13.3335 10.0002 13.1843 10.0002 13.0002V3.00016Z"
        fill="#008753"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00016 7.3335C2.07969 7.3335 1.3335 8.07969 1.3335 9.00016V13.0002C1.3335 13.9206 2.07969 14.6668 3.00016 14.6668H5.66683C6.5873 14.6668 7.3335 13.9206 7.3335 13.0002V9.00016C7.3335 8.07969 6.5873 7.3335 5.66683 7.3335H3.00016ZM2.66683 9.00016C2.66683 8.81607 2.81607 8.66683 3.00016 8.66683H5.66683C5.85092 8.66683 6.00016 8.81607 6.00016 9.00016V13.0002C6.00016 13.1843 5.85092 13.3335 5.66683 13.3335H3.00016C2.81607 13.3335 2.66683 13.1843 2.66683 13.0002V9.00016Z"
        fill="#008753"
      />
    </svg>
  )
}
export function ChevronRight(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 12 12"
      fill="none"
      style={props.style}
      className={props.className}
    >
      <path
        d="M4.25 2.75L7.75 6.25L4.25 9.75"
        stroke="currentcolor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function ChevronLeft(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      style={props.style}
    >
      <path
        d="M7.75 9.75L4.25 6.25L7.75 2.75"
        stroke="#232325"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PerformanceIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9503 16.2502C17.4253 14.7502 18.3337 12.6835 18.3337 10.4168C18.3337 5.81683 14.6003 2.0835 10.0003 2.0835C5.40033 2.0835 1.66699 5.81683 1.66699 10.4168C1.66699 12.6835 2.56699 14.7335 4.03366 16.2418"
        stroke="#101828"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 17.9165C11.5559 17.9165 12.8169 16.6555 12.8169 15.0999C12.8169 13.5443 11.5559 12.2832 10.0003 12.2832C8.44466 12.2832 7.18359 13.5443 7.18359 15.0999C7.18359 16.6555 8.44466 17.9165 10.0003 17.9165Z"
        stroke="#101828"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.708 10H13.333C14.0163 10 14.583 9.44167 14.583 8.75C14.583 8.06667 14.0163 7.5 13.333 7.5C12.6497 7.5 12.083 8.05833 12.083 8.75V9.375C12.083 9.71667 12.3663 10 12.708 10Z"
        stroke="#101828"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function RefreshIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3332 9.99996C18.3332 14.6 14.5998 18.3333 9.99984 18.3333C5.39984 18.3333 2.5915 13.7 2.5915 13.7M2.5915 13.7H6.35817M2.5915 13.7V17.8666M1.6665 9.99996C1.6665 5.39996 5.3665 1.66663 9.99984 1.66663C15.5582 1.66663 18.3332 6.29996 18.3332 6.29996M18.3332 6.29996V2.13329M18.3332 6.29996H14.6332"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function PreviousIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8332 10.0001H4.1665M4.1665 10.0001L9.99984 15.8334M4.1665 10.0001L9.99984 4.16675"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function NextIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.1665 7.00008H12.8332M12.8332 7.00008L6.99984 1.16675M12.8332 7.00008L6.99984 12.8334"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function HamburgerMenu() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 7H21"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        opacity="0.34"
        d="M3 12H21"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 17H21"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
export function HorizontalEllipses(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10Z"
        stroke="#292D32"
        strokeWidth="1.5"
      />
      <path
        d="M19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10Z"
        stroke="#1ABB9C"
        strokeWidth="1.5"
      />
      <path
        opacity="0.4"
        d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        stroke="#292D32"
        strokeWidth="1.5"
      />
    </svg>
  )
}
export function NotificationIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M12.0201 2.91003C8.71009 2.91003 6.02009 5.60003 6.02009 8.91003V11.8C6.02009 12.41 5.76009 13.34 5.45009 13.86L4.30009 15.77C3.59009 16.95 4.08009 18.26 5.38009 18.7C9.69009 20.14 14.3401 20.14 18.6501 18.7C19.8601 18.3 20.3901 16.87 19.7301 15.77L18.5801 13.86C18.2801 13.34 18.0201 12.41 18.0201 11.8V8.91003C18.0201 5.61003 15.3201 2.91003 12.0201 2.91003Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.8699 3.19994C13.5599 3.10994 13.2399 3.03994 12.9099 2.99994C11.9499 2.87994 11.0299 2.94994 10.1699 3.19994C10.4599 2.45994 11.1799 1.93994 12.0199 1.93994C12.8599 1.93994 13.5799 2.45994 13.8699 3.19994Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
export function RecallUserIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M3.41003 22C3.41003 18.13 7.26003 15 12 15C12.96 15 13.89 15.13 14.76 15.37"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 18C22 18.75 21.79 19.46 21.42 20.06C21.21 20.42 20.94 20.74 20.63 21C19.93 21.63 19.01 22 18 22C16.54 22 15.27 21.22 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.74 14.58 15.61 15.5 14.88C16.19 14.33 17.06 14 18 14C20.21 14 22 15.79 22 18Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4399 18L17.4299 18.99L19.5599 17.02"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function ShieldIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M10.4899 2.23006L5.49991 4.11006C4.34991 4.54006 3.40991 5.90006 3.40991 7.12006V14.5501C3.40991 15.7301 4.18991 17.2801 5.13991 17.9901L9.43991 21.2001C10.8499 22.2601 13.1699 22.2601 14.5799 21.2001L18.8799 17.9901C19.8299 17.2801 20.6099 15.7301 20.6099 14.5501V7.12006C20.6099 5.89006 19.6699 4.53006 18.5199 4.10006L13.5299 2.23006C12.6799 1.92006 11.3199 1.92006 10.4899 2.23006Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.05005 11.8699L10.66 13.4799L14.96 9.17993"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function SuspendUserIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <g opacity="0.4">
        <path
          d="M18.4098 18.0898L15.5898 20.9098"
          stroke="#1ABB9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.4098 20.9098L15.5898 18.0898"
          stroke="#292D32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        opacity="0.4"
        d="M12.1601 10.87C12.0601 10.86 11.9401 10.86 11.8301 10.87C9.45006 10.79 7.56006 8.84 7.56006 6.44C7.56006 3.99 9.54006 2 12.0001 2C14.4501 2 16.4401 3.99 16.4401 6.44C16.4301 8.84 14.5401 10.79 12.1601 10.87Z"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21.8101C10.18 21.8101 8.37005 21.3501 6.99005 20.4301C4.57005 18.8101 4.57005 16.1701 6.99005 14.5601C9.74005 12.7201 14.25 12.7201 17 14.5601"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function BlockIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function ActiveIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function TransferIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <g opacity="0.4">
        <path
          d="M17.2803 10.45L21.0002 6.72998L17.2803 3.01001"
          stroke="#1ABB9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 6.72998H21"
          stroke="#1ABB9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M6.71997 13.55L3 17.2701L6.71997 20.9901"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 17.27H3"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function PersonRoleIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M18 18.86H17.24C16.44 18.86 15.68 19.17 15.12 19.73L13.41 21.42C12.63 22.19 11.36 22.19 10.58 21.42L8.87 19.73C8.31 19.17 7.54 18.86 6.75 18.86H6C4.34 18.86 3 17.53 3 15.89V4.97998C3 3.33998 4.34 2.01001 6 2.01001H18C19.66 2.01001 21 3.33998 21 4.97998V15.89C21 17.52 19.66 18.86 18 18.86Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.9999 10.0001C13.2868 10.0001 14.33 8.95687 14.33 7.67004C14.33 6.38322 13.2868 5.34009 11.9999 5.34009C10.7131 5.34009 9.66992 6.38322 9.66992 7.67004C9.66992 8.95687 10.7131 10.0001 11.9999 10.0001Z"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M16 15.66C16 13.86 14.21 12.4 12 12.4C9.79 12.4 8 13.86 8 15.66"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function SendIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M9.51002 4.22989L18.07 8.50989C21.91 10.4299 21.91 13.5699 18.07 15.4899L9.51002 19.7699C3.75002 22.6499 1.40002 20.2899 4.28002 14.5399L5.15002 12.8099C5.37002 12.3699 5.37002 11.6399 5.15002 11.1999L4.28002 9.45989C1.40002 3.70989 3.76002 1.34989 9.51002 4.22989Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M5.43994 12H10.8399"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function SendWhiteIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M9.51002 4.22989L18.07 8.50989C21.91 10.4299 21.91 13.5699 18.07 15.4899L9.51002 19.7699C3.75002 22.6499 1.40002 20.2899 4.28002 14.5399L5.15002 12.8099C5.37002 12.3699 5.37002 11.6399 5.15002 11.1999L4.28002 9.45989C1.40002 3.70989 3.76002 1.34989 9.51002 4.22989Z"
        stroke="#FFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M5.43994 12H10.8399"
        stroke="#FFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function SecurityIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M10.4899 2.23006L5.49991 4.11006C4.34991 4.54006 3.40991 5.90006 3.40991 7.12006V14.5501C3.40991 15.7301 4.18991 17.2801 5.13991 17.9901L9.43991 21.2001C10.8499 22.2601 13.1699 22.2601 14.5799 21.2001L18.8799 17.9901C19.8299 17.2801 20.6099 15.7301 20.6099 14.5501V7.12006C20.6099 5.89006 19.6699 4.53006 18.5199 4.10006L13.5299 2.23006C12.6799 1.92006 11.3199 1.92006 10.4899 2.23006Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M12 12.5C13.1046 12.5 14 11.6046 14 10.5C14 9.39543 13.1046 8.5 12 8.5C10.8954 8.5 10 9.39543 10 10.5C10 11.6046 10.8954 12.5 12 12.5Z"
          stroke="#1ABB9C"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12.5V15.5"
          stroke="#292D32"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
export function PhotoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.76 22H17.24C20 22 21.1 20.31 21.23 18.25L21.75 9.99C21.89 7.83 20.17 6 18 6C17.39 6 16.83 5.65 16.55 5.11L15.83 3.66C15.37 2.75 14.17 2 13.15 2H10.86C9.83 2 8.63 2.75 8.17 3.66L7.45 5.11C7.17 5.65 6.61 6 6 6C3.83 6 2.11 7.83 2.25 9.99L2.77 18.25C2.89 20.31 4 22 6.76 22Z"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M10.5 8H13.5"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M12 18C13.79 18 15.25 16.54 15.25 14.75C15.25 12.96 13.79 11.5 12 11.5C10.21 11.5 8.75 12.96 8.75 14.75C8.75 16.54 10.21 18 12 18Z"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FileIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
      className={props.className}
    >
      <path
        d="M9.00049 22H15.0005C20.0005 22 22.0005 20 22.0005 15V9C22.0005 4 20.0005 2 15.0005 2H9.00049C4.00049 2 2.00049 4 2.00049 9V15C2.00049 20 4.00049 22 9.00049 22Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M15.7505 9H8.25049"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M15.7505 15H8.25049"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function EscalateIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <g opacity="0.4">
        <path
          d="M16.5 9.5L12.3 13.7L10.7 11.3L7.5 14.5"
          stroke="#1ABB9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5 9.5H16.5V11.5"
          stroke="#1ABB9C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function PostIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M9.51002 4.22989L18.07 8.50989C21.91 10.4299 21.91 13.5699 18.07 15.4899L9.51002 19.7699C3.75002 22.6499 1.40002 20.2899 4.28002 14.5399L5.15002 12.8099C5.37002 12.3699 5.37002 11.6399 5.15002 11.1999L4.28002 9.45989C1.40002 3.70989 3.76002 1.34989 9.51002 4.22989Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M5.43994 12H10.8399"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CloseClipboardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.4">
        <path
          d="M13.9991 16.1602L10.0391 12.2002"
          stroke="#1ABB9C"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.96 12.2402L10 16.2002"
          stroke="#1ABB9C"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function ComputerChip() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.6 20.75C5.21 20.75 3.25 18.79 3.25 14.4V9.6C3.25 5.21 5.21 3.25 9.6 3.25H14.4C18.79 3.25 20.75 5.21 20.75 9.6C20.75 10.01 20.41 10.35 20 10.35C19.59 10.35 19.25 10.01 19.25 9.6C19.25 6.02 17.98 4.75 14.4 4.75H9.6C6.02 4.75 4.75 6.02 4.75 9.6V14.4C4.75 17.98 6.02 19.25 9.6 19.25C10.01 19.25 10.35 19.59 10.35 20C10.35 20.41 10.01 20.75 9.6 20.75Z"
        fill="currentcolor"
      />
      <path
        d="M7.98999 17.1C7.82999 17.1 7.65999 17.05 7.51999 16.94C6.64999 16.25 6.23999 15.15 6.23999 13.5V10.5C6.23999 7.6 7.58999 6.25 10.49 6.25H13.49C15.14 6.25 16.23 6.66 16.93 7.53C17.19 7.85 17.13 8.33 16.81 8.58C16.49 8.84 16.01 8.79 15.76 8.46C15.52 8.15 15.02 7.75 13.5 7.75H10.5C8.41999 7.75 7.74999 8.42 7.74999 10.5V13.5C7.74999 15.02 8.15999 15.52 8.45999 15.76C8.77999 16.02 8.83999 16.49 8.57999 16.81C8.42999 17 8.20999 17.1 7.98999 17.1Z"
        fill="currentcolor"
      />
      <path
        d="M8.01001 4.75C7.59001 4.75 7.26001 4.41 7.26001 4V2C7.26001 1.59 7.60001 1.25 8.01001 1.25C8.42001 1.25 8.76001 1.59 8.76001 2V4C8.76001 4.41 8.42001 4.75 8.01001 4.75Z"
        fill="currentcolor"
      />
      <path
        d="M12 4.75C11.59 4.75 11.25 4.41 11.25 4V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V4C12.75 4.41 12.41 4.75 12 4.75Z"
        fill="currentcolor"
      />
      <path
        d="M16 4.75C15.59 4.75 15.25 4.41 15.25 4V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V4C16.75 4.41 16.41 4.75 16 4.75Z"
        fill="currentcolor"
      />
      <path
        d="M22 8.75H20C19.59 8.75 19.25 8.41 19.25 8C19.25 7.59 19.59 7.25 20 7.25H22C22.41 7.25 22.75 7.59 22.75 8C22.75 8.41 22.42 8.75 22 8.75Z"
        fill="currentcolor"
      />
      <path
        d="M8.01001 22.75C7.60001 22.75 7.26001 22.41 7.26001 22V20C7.26001 19.59 7.60001 19.25 8.01001 19.25C8.42001 19.25 8.76001 19.59 8.76001 20V22C8.76001 22.41 8.42001 22.75 8.01001 22.75Z"
        fill="currentcolor"
      />
      <path
        d="M4 8.75H2C1.59 8.75 1.25 8.42 1.25 8C1.25 7.58 1.59 7.25 2 7.25H4C4.41 7.25 4.75 7.59 4.75 8C4.75 8.41 4.42 8.75 4 8.75Z"
        fill="currentcolor"
      />
      <path
        d="M4 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H4C4.41 11.25 4.75 11.59 4.75 12C4.75 12.41 4.42 12.75 4 12.75Z"
        fill="currentcolor"
      />
      <path
        d="M4 16.75H2C1.59 16.75 1.25 16.41 1.25 16C1.25 15.59 1.59 15.25 2 15.25H4C4.41 15.25 4.75 15.59 4.75 16C4.75 16.41 4.42 16.75 4 16.75Z"
        fill="currentcolor"
      />
      <path
        d="M16.71 19.34C15.42 19.34 14.37 18.29 14.37 17C14.37 15.71 15.42 14.66 16.71 14.66C18 14.66 19.05 15.71 19.05 17C19.04 18.29 18 19.34 16.71 19.34ZM16.71 16.16C16.25 16.16 15.87 16.54 15.87 17C15.87 17.46 16.25 17.84 16.71 17.84C17.17 17.84 17.55 17.46 17.55 17C17.54 16.54 17.17 16.16 16.71 16.16Z"
        fill="currentcolor"
      />
      <path
        d="M18.4 22.75C17.84 22.75 17.29 22.46 16.99 21.94L16.92 21.83C16.81 21.64 16.72 21.59 16.7 21.58C16.69 21.58 16.59 21.64 16.48 21.83L16.42 21.93C15.96 22.72 14.95 22.98 14.18 22.52L13.28 22C12.87 21.77 12.58 21.39 12.46 20.93C12.34 20.48 12.4 20 12.63 19.6C12.74 19.41 12.74 19.3 12.73 19.28C12.72 19.27 12.63 19.22 12.41 19.22C11.44 19.22 10.65 18.43 10.65 17.47V16.54C10.65 15.57 11.44 14.79 12.4 14.79C12.62 14.79 12.71 14.73 12.73 14.72C12.73 14.71 12.73 14.6 12.62 14.41C12.39 14 12.32 13.53 12.45 13.08C12.57 12.63 12.86 12.25 13.27 12.01L14.18 11.48C14.94 11.03 15.95 11.29 16.4 12.07L16.46 12.18C16.57 12.37 16.66 12.42 16.68 12.43C16.69 12.43 16.79 12.37 16.9 12.18L16.96 12.08C17.43 11.29 18.43 11.03 19.2 11.49L20.13 12C20.54 12.23 20.83 12.61 20.95 13.07C21.07 13.52 21.01 14 20.78 14.4C20.67 14.59 20.67 14.7 20.68 14.72C20.69 14.73 20.78 14.78 21 14.78C21.97 14.78 22.76 15.57 22.76 16.53V17.46C22.76 18.43 21.97 19.21 21.01 19.21C20.79 19.21 20.7 19.27 20.68 19.28C20.68 19.29 20.68 19.4 20.79 19.59C21.02 20 21.09 20.47 20.96 20.92C20.84 21.37 20.55 21.75 20.14 21.99L19.23 22.52C18.96 22.67 18.68 22.75 18.4 22.75ZM16.71 20.08C17.31 20.08 17.86 20.44 18.23 21.08L18.29 21.19C18.32 21.24 18.4 21.27 18.46 21.23L19.38 20.7C19.46 20.66 19.49 20.58 19.5 20.54C19.51 20.5 19.52 20.43 19.48 20.35C19.11 19.72 19.08 19.06 19.38 18.54C19.68 18.02 20.27 17.72 21 17.72C21.14 17.72 21.26 17.6 21.26 17.47V16.54C21.26 16.4 21.14 16.29 21.01 16.29C20.28 16.29 19.68 15.99 19.39 15.47C19.09 14.95 19.13 14.29 19.49 13.66C19.54 13.58 19.53 13.5 19.51 13.47C19.5 13.43 19.47 13.36 19.39 13.31L18.48 12.78C18.41 12.74 18.33 12.77 18.29 12.83L18.24 12.92C17.87 13.56 17.32 13.92 16.72 13.92C16.12 13.92 15.57 13.56 15.2 12.92L15.14 12.82C15.11 12.76 15.02 12.74 14.97 12.77L14.05 13.3C13.97 13.34 13.94 13.42 13.93 13.46C13.92 13.5 13.91 13.57 13.95 13.65C14.32 14.28 14.35 14.94 14.05 15.46C13.75 15.98 13.16 16.28 12.43 16.28C12.29 16.28 12.17 16.4 12.17 16.53V17.46C12.17 17.6 12.29 17.71 12.42 17.71C13.15 17.71 13.75 18.01 14.04 18.53C14.34 19.05 14.3 19.71 13.94 20.34C13.9 20.42 13.91 20.49 13.92 20.53C13.93 20.57 13.96 20.64 14.04 20.69L14.95 21.22C15.02 21.26 15.1 21.23 15.14 21.17L15.19 21.07C15.55 20.44 16.11 20.08 16.71 20.08Z"
        fill="currentcolor"
      />
    </svg>
  )
}
export function EditIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      className={props.className}
    >
      <path
        opacity="0.4"
        d="M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z"
        fill="currentcolor"
      />
      <path
        opacity="0.4"
        d="M19.0201 3.47997C17.0801 1.53997 15.1801 1.48997 13.1901 3.47997L11.9801 4.68997C11.8801 4.78997 11.8401 4.94997 11.8801 5.08997C12.6401 7.73997 14.7601 9.85997 17.4101 10.62C17.4501 10.63 17.4901 10.64 17.5301 10.64C17.6401 10.64 17.7401 10.6 17.8201 10.52L19.0201 9.30997C20.0101 8.32997 20.4901 7.37997 20.4901 6.41997C20.5001 5.42997 20.0201 4.46997 19.0201 3.47997Z"
        fill="#1ABB9C"
      />
      <path
        d="M15.6101 11.53C15.3201 11.39 15.0401 11.25 14.7701 11.09C14.5501 10.96 14.3401 10.82 14.1301 10.67C13.9601 10.56 13.7601 10.4 13.5701 10.24C13.5501 10.23 13.4801 10.17 13.4001 10.09C13.0701 9.80999 12.7001 9.44999 12.3701 9.04999C12.3401 9.02999 12.2901 8.95999 12.2201 8.86999C12.1201 8.74999 11.9501 8.54999 11.8001 8.31999C11.6801 8.16999 11.5401 7.94999 11.4101 7.72999C11.2501 7.45999 11.1101 7.18999 10.9701 6.90999C10.8301 6.60999 10.7201 6.31999 10.6201 6.04999L4.34007 12.33C4.21007 12.46 4.09007 12.71 4.06007 12.88L3.52007 16.71C3.42007 17.39 3.61007 18.03 4.03007 18.46C4.39007 18.81 4.89007 19 5.43007 19C5.55007 19 5.67007 18.99 5.79007 18.97L9.63007 18.43C9.81007 18.4 10.0601 18.28 10.1801 18.15L16.4601 11.87C16.1801 11.77 15.9101 11.66 15.6101 11.53Z"
        fill="currentcolor"
      />
    </svg>
  )
}

export function FlagIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M6.44995 2V22"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.34"
        d="M6.94995 4L15.05 7.5C18.35 8.9 18.35 11.3 15.25 12.9L6.94995 17"
        stroke="#1ABB9C"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function CircledPlus(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM11 7C11 6.73478 10.8946 6.48043 10.7071 6.29289C10.5196 6.10536 10.2652 6 10 6C9.73478 6 9.48043 6.10536 9.29289 6.29289C9.10536 6.48043 9 6.73478 9 7V9H7C6.73478 9 6.48043 9.10536 6.29289 9.29289C6.10536 9.48043 6 9.73478 6 10C6 10.2652 6.10536 10.5196 6.29289 10.7071C6.48043 10.8946 6.73478 11 7 11H9V13C9 13.2652 9.10536 13.5196 9.29289 13.7071C9.48043 13.8946 9.73478 14 10 14C10.2652 14 10.5196 13.8946 10.7071 13.7071C10.8946 13.5196 11 13.2652 11 13V11H13C13.2652 11 13.5196 10.8946 13.7071 10.7071C13.8946 10.5196 14 10.2652 14 10C14 9.73478 13.8946 9.48043 13.7071 9.29289C13.5196 9.10536 13.2652 9 13 9H11V7Z"
        fill="#068068"
      />
    </svg>
  )
}
export function ShareIcon(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
    >
      <path
        d="M3.3335 6V10.6667"
        stroke="#068068"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.50016 5.66658C4.69678 5.66658 5.66683 4.69654 5.66683 3.49992C5.66683 2.3033 4.69678 1.33325 3.50016 1.33325C2.30355 1.33325 1.3335 2.3033 1.3335 3.49992C1.3335 4.69654 2.30355 5.66658 3.50016 5.66658Z"
        stroke="#068068"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.3335 14.6667C4.43807 14.6667 5.3335 13.7713 5.3335 12.6667C5.3335 11.5622 4.43807 10.6667 3.3335 10.6667C2.22893 10.6667 1.3335 11.5622 1.3335 12.6667C1.3335 13.7713 2.22893 14.6667 3.3335 14.6667Z"
        stroke="#068068"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6665 14.6667C13.7711 14.6667 14.6665 13.7713 14.6665 12.6667C14.6665 11.5622 13.7711 10.6667 12.6665 10.6667C11.5619 10.6667 10.6665 11.5622 10.6665 12.6667C10.6665 13.7713 11.5619 14.6667 12.6665 14.6667Z"
        stroke="#068068"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.41992 6C3.71992 7.16667 4.78659 8.03334 6.04659 8.02667L8.33326 8.02C10.0799 8.01333 11.5666 9.13334 12.1133 10.6933"
        stroke="#068068"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function DeleteIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8499 9.13989L18.1999 19.2099C18.0899 20.7799 17.9999 21.9999 15.2099 21.9999H8.7899C5.9999 21.9999 5.9099 20.7799 5.7999 19.2099L5.1499 9.13989"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3301 16.5H13.6601"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 12.5H14.5"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export function Calendar(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={props.style}
    >
      <path
        d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z"
        fill="#292D32"
      />
      <path
        d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z"
        fill="#292D32"
      />
      <path
        d="M8.5 14.5001C8.37 14.5001 8.24 14.4701 8.12 14.4201C7.99 14.3701 7.89 14.3001 7.79 14.2101C7.61 14.0201 7.5 13.7701 7.5 13.5001C7.5 13.3701 7.53 13.2401 7.58 13.1201C7.63 13.0001 7.7 12.8901 7.79 12.7901C7.89 12.7001 7.99 12.6301 8.12 12.5801C8.48 12.4301 8.93 12.5101 9.21 12.7901C9.39 12.9801 9.5 13.2401 9.5 13.5001C9.5 13.5601 9.49 13.6301 9.48 13.7001C9.47 13.7601 9.45 13.8201 9.42 13.8801C9.4 13.9401 9.37 14.0001 9.33 14.0601C9.3 14.1101 9.25 14.1601 9.21 14.2101C9.02 14.3901 8.76 14.5001 8.5 14.5001Z"
        fill="#292D32"
      />
      <path
        d="M12 14.5C11.87 14.5 11.74 14.47 11.62 14.42C11.49 14.37 11.39 14.3 11.29 14.21C11.11 14.02 11 13.77 11 13.5C11 13.37 11.03 13.24 11.08 13.12C11.13 13 11.2 12.89 11.29 12.79C11.39 12.7 11.49 12.63 11.62 12.58C11.98 12.42 12.43 12.51 12.71 12.79C12.89 12.98 13 13.24 13 13.5C13 13.56 12.99 13.63 12.98 13.7C12.97 13.76 12.95 13.82 12.92 13.88C12.9 13.94 12.87 14 12.83 14.06C12.8 14.11 12.75 14.16 12.71 14.21C12.52 14.39 12.26 14.5 12 14.5Z"
        fill="#292D32"
      />
      <path
        d="M15.5 14.5C15.37 14.5 15.24 14.47 15.12 14.42C14.99 14.37 14.89 14.3 14.79 14.21C14.75 14.16 14.71 14.11 14.67 14.06C14.63 14 14.6 13.94 14.58 13.88C14.55 13.82 14.53 13.76 14.52 13.7C14.51 13.63 14.5 13.56 14.5 13.5C14.5 13.24 14.61 12.98 14.79 12.79C14.89 12.7 14.99 12.63 15.12 12.58C15.49 12.42 15.93 12.51 16.21 12.79C16.39 12.98 16.5 13.24 16.5 13.5C16.5 13.56 16.49 13.63 16.48 13.7C16.47 13.76 16.45 13.82 16.42 13.88C16.4 13.94 16.37 14 16.33 14.06C16.3 14.11 16.25 14.16 16.21 14.21C16.02 14.39 15.76 14.5 15.5 14.5Z"
        fill="#292D32"
      />
      <path
        d="M8.5 17.9999C8.37 17.9999 8.24 17.97 8.12 17.92C8 17.87 7.89 17.7999 7.79 17.7099C7.61 17.5199 7.5 17.2599 7.5 16.9999C7.5 16.8699 7.53 16.7399 7.58 16.6199C7.63 16.4899 7.7 16.38 7.79 16.29C8.16 15.92 8.84 15.92 9.21 16.29C9.39 16.48 9.5 16.7399 9.5 16.9999C9.5 17.2599 9.39 17.5199 9.21 17.7099C9.02 17.8899 8.76 17.9999 8.5 17.9999Z"
        fill="#292D32"
      />
      <path
        d="M12 17.9999C11.74 17.9999 11.48 17.8899 11.29 17.7099C11.11 17.5199 11 17.2599 11 16.9999C11 16.8699 11.03 16.7399 11.08 16.6199C11.13 16.4899 11.2 16.38 11.29 16.29C11.66 15.92 12.34 15.92 12.71 16.29C12.8 16.38 12.87 16.4899 12.92 16.6199C12.97 16.7399 13 16.8699 13 16.9999C13 17.2599 12.89 17.5199 12.71 17.7099C12.52 17.8899 12.26 17.9999 12 17.9999Z"
        fill="#292D32"
      />
      <path
        d="M15.5 18C15.24 18 14.98 17.89 14.79 17.71C14.7 17.62 14.63 17.51 14.58 17.38C14.53 17.26 14.5 17.13 14.5 17C14.5 16.87 14.53 16.74 14.58 16.62C14.63 16.49 14.7 16.38 14.79 16.29C15.02 16.06 15.37 15.95 15.69 16.02C15.76 16.03 15.82 16.05 15.88 16.08C15.94 16.1 16 16.13 16.06 16.17C16.11 16.2 16.16 16.25 16.21 16.29C16.39 16.48 16.5 16.74 16.5 17C16.5 17.26 16.39 17.52 16.21 17.71C16.02 17.89 15.76 18 15.5 18Z"
        fill="#292D32"
      />
      <path
        d="M20.5 9.83997H3.5C3.09 9.83997 2.75 9.49997 2.75 9.08997C2.75 8.67997 3.09 8.33997 3.5 8.33997H20.5C20.91 8.33997 21.25 8.67997 21.25 9.08997C21.25 9.49997 20.91 9.83997 20.5 9.83997Z"
        fill="#292D32"
      />
      <path
        d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z"
        fill="#292D32"
      />
    </svg>
  )
}
export function EyeClosed(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      style={props.style}
    >
      <g opacity="0.3">
        <path
          d="M21.2714 8.35022C20.9814 7.89022 20.6714 7.46022 20.3514 7.06022C19.9814 6.59022 19.2814 6.55022 18.8614 6.97022L15.8614 9.97022C16.0814 10.6302 16.1214 11.3902 15.9214 12.1802C15.5714 13.5902 14.4314 14.7302 13.0214 15.0802C12.2314 15.2802 11.4714 15.2402 10.8114 15.0202C10.8114 15.0202 9.38141 16.4502 8.35141 17.4802C7.85141 17.9802 8.01141 18.8602 8.68141 19.1202C9.75141 19.5302 10.8614 19.7402 12.0014 19.7402C13.7814 19.7402 15.5114 19.2202 17.0914 18.2502C18.7014 17.2502 20.1514 15.7802 21.3214 13.9102C22.2714 12.4002 22.2214 9.86022 21.2714 8.35022Z"
          fill="currentcolor"
        />
        <path
          d="M14.0206 9.1525L9.98062 13.1925C9.47062 12.6725 9.14062 11.9525 9.14062 11.1725C9.14062 9.6025 10.4206 8.3125 12.0006 8.3125C12.7806 8.3125 13.5006 8.6425 14.0206 9.1525Z"
          fill="currentcolor"
        />
        <path
          d="M18.25 4.92156L14.86 8.31156C14.13 7.57156 13.12 7.13156 12 7.13156C9.76 7.13156 7.96 8.94156 7.96 11.1716C7.96 12.2916 8.41 13.3016 9.14 14.0316L5.76 17.4216H5.75C4.64 16.5216 3.62 15.3716 2.75 14.0116C1.75 12.4416 1.75 9.89156 2.75 8.32156C3.91 6.50156 5.33 5.07156 6.91 4.09156C8.49 3.13156 10.22 2.60156 12 2.60156C14.23 2.60156 16.39 3.42156 18.25 4.92156Z"
          fill="currentcolor"
        />
        <path
          d="M14.8581 11.17C14.8581 12.74 13.5781 14.03 11.9981 14.03C11.9381 14.03 11.8881 14.03 11.8281 14.01L14.8381 11C14.8581 11.06 14.8581 11.11 14.8581 11.17Z"
          fill="currentcolor"
        />
        <path
          d="M21.7689 1.40078C21.4689 1.10078 20.9789 1.10078 20.6789 1.40078L2.22891 19.8608C1.92891 20.1608 1.92891 20.6508 2.22891 20.9508C2.37891 21.0908 2.56891 21.1708 2.76891 21.1708C2.96891 21.1708 3.15891 21.0908 3.30891 20.9408L21.7689 2.48078C22.0789 2.18078 22.0789 1.70078 21.7689 1.40078Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  )
}
export function EyeOpened(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      width="24"
      height="25"
      style={props.style}
    >
      <g opacity="0.3">
        <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" fill="currentcolor" />
        <path
          fillRule="evenodd"
          fill="currentcolor"
          d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  )
}

export function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.66667 10.6667H8V8H7.33333M8 5.33333H8.00667M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
        stroke="currentcolor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
